// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:37:01.619Z
// Property: Redbud Ranch (ID: 6767906449165623)
// Collections: 23 amenities, 12 floorplans (live), 27 photos, 77 POIs, 3 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165623",
  "property_external_id": "ewcy81q",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/redbud-ranch-broken-arrow-ok/ewcy81q/",
  "property_google_business_url": "https://www.google.com/maps/place/Redbud+Ranch+Apartments/data=!4m2!3m1!1s0x0:0xa0d965e04b94f06e?sa=X&ved=2ahUKEwjI2pfa_rySAxUUmbAFHT1aKZMQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "redbud-ranch",
  "property_name": "Redbud Ranch",
  "property_website_url": "https://www.caseusa.com/apartments/ok/broken-arrow/redbud-ranch/",
  "property_domain": null,
  "property_address": "2701 North 23rd St",
  "property_full_address": "2701 North 23rd St, Broken Arrow, OK, 74014",
  "property_address_1": "2701 North 23rd St",
  "property_address_2": null,
  "property_address_city": "Broken Arrow",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74014",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "https://www.caseusa.com/apartments/ok/broken-arrow/north-23rd-st/#/",
  "property_address_latitude": "36.0789",
  "property_address_longitude": "-95.76097",
  "property_email": "redbud@caseusa.com",
  "property_phone": "(539) 379-5663",
  "property_call_tracking_phone": "855-953-4576",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Redbud Ranch in Broken Arrow, Oklahoma, our vibrant community offers a variety of thoughtfully designed floor plans—one, two, and three bedrooms—catering to every lifestyle. Enjoy luxurious amenities, from our sparkling pool and fitness center to pet-friendly spaces. Your perfect home awaits—browse availability or schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to **Redbud Ranch**, your perfect urban oasis nestled in the heart of Broken Arrow, Oklahoma. Experience modern living with our diverse range of floor plans, including stylish one, two, and three-bedroom apartments designed to suit every lifestyle. Step inside and discover spacious layouts featuring high ceilings, walk-in closets, and cozy fireplaces – perfect for creating your ideal home.\n\nAt Redbud Ranch, we believe in offering more than just a place to live. Our exceptional amenities are tailored to enhance your lifestyle. Dive into our sparkling pool, break a sweat in the state-of-the-art fitness center, or unwind in the spacious clubhouse. Enjoy the outdoors? Take advantage of our beautifully landscaped courtyard, complete with a picnic area, designated dog park, and a fun-filled gameroom for family and friends.\n\nOur community is gated for your security, while our dedicated on-site property management and maintenance teams ensure your experience is seamless. With 24-hour access to online services, we put your convenience first. Let your pets frolic in the pet play area while you relax on your private balcony or patio.\n\nWith high-speed internet access and in-unit features such as air conditioning, modern kitchens, and dishwashers, Redbud Ranch combines comfort with convenience. Whether you prefer a quiet retreat or a place for gatherings, we have everything you need right here.\n\nDon't wait to make Redbud Ranch your new home! **Browse our availability or schedule a tour today to experience the community lifestyle you've been craving!**",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fb44b-92d7-73ad-a57c-0797f86344ae.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of a modern multifamily property with a white building, black roof, and manicured landscaping.",
    "public_id": "019fb44b-92d7-73ad-a57c-0797f86344ae",
    "storage_key": "property/6767906449165623/019fb44b-92d7-73ad-a57c-0797f86344ae.webp",
    "width": 1280,
    "height": 852
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "309",
  "property_year_built": "2022",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.73462783171522",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "225-425",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "breed restrictions apply",
  "property_pet_policy_description": "80lbs max",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://redbudranchapartmentsba.securecafe.com/onlineleasing/redbud-ranch/floorplans.aspx",
  "property_resident_portal_url": "https://redbudranchapartmentsba.securecafe.com/residentservices/redbud-ranch/userlogin.aspx",
  "property_apply_now_url": "https://redbudranchapartmentsba.securecafe.com/onlineleasing/redbud-ranch/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-4f35-769f-aadc-9335630048e3.webp",
  "property_primary_logo_media": {
    "alt_text": "Redbud Ranch Apartments logo",
    "public_id": "019cfb46-4f35-769f-aadc-9335630048e3",
    "storage_key": "property/6767906449165623/019cfb46-4f35-769f-aadc-9335630048e3.webp",
    "width": 735,
    "height": 391
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb47-c53c-7065-8d8f-1e70ad648eb3.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb47-c53c-7065-8d8f-1e70ad648eb3",
    "storage_key": "property/6767906449165623/019cfb47-c53c-7065-8d8f-1e70ad648eb3.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb47-db2c-767b-ac3e-57452eb2dbc0.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Redbud Ranch Apartments logo",
    "public_id": "019cfb47-db2c-767b-ac3e-57452eb2dbc0",
    "storage_key": "property/6767906449165623/019cfb47-db2c-767b-ac3e-57452eb2dbc0.webp",
    "width": 640,
    "height": 340
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb47-e578-77a8-bda2-fd827708e328.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Redbud Apartments Ranch logo",
    "public_id": "019cfb47-e578-77a8-bda2-fd827708e328",
    "storage_key": "property/6767906449165623/019cfb47-e578-77a8-bda2-fd827708e328.webp",
    "width": 640,
    "height": 340
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#000000",
  "property_secondary_color": "#92345b",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#504942",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "789 - 1435",
  "property_sqft_min": "789",
  "property_sqft_max": "1435",
  "property_price_range": "1169 - 1949",
  "property_price_min": "1169",
  "property_price_max": "1949",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/redbudranchok/",
  "property_instagram_url": "https://www.instagram.com/explore/locations/103524998977376/redbud-ranch-apartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJOXDrCg2LtocRbvCUS-Bl2aA",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_loc=Broken+Arrow%2C+OK",
  "property_tiktok_url": "https://www.tiktok.com/discover/redbud-ranch-apartments-broken-arrow",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Redbud Ranch",
  "property_home_romance_title": "Embrace Your Ideal Lifestyle in Our Charming Apartment Community",
  "property_home_amenities_blurb": "Welcome to Redbud Ranch in Broken Arrow, Oklahoma, where modern living meets comfort. Choose from spacious one, two, or three-bedroom floor plans, and enjoy resort-style amenities including a pool, fitness center, and pet-friendly areas. Elevated living awaits—your ideal home is just a visit away!",
  "property_home_floorplans_blurb": "Welcome to Redbud Ranch in Broken Arrow, Oklahoma, where comfort meets style! Choose from our thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. Browse our available apartment homes today and embrace the perfect blend of modern living and serene surroundings. Your ideal home awaits!",
  "property_home_gallery_blurb": "Welcome to Redbud Ranch in Broken Arrow, Oklahoma—where comfort meets convenience. Choose from stylish one, two, or three-bedroom floor plans tailored to your lifestyle. Enhance your days by lounging by the pool, working out in the fitness center, or enjoying evenings at our cozy clubhouse. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Redbud Ranch, where comfort meets convenience in Broken Arrow, Oklahoma. Enjoy spacious one, two, and three-bedroom floor plans nestled near parks, libraries, and educational institutions. Unwind at local attractions like the Museum Broken Arrow and Tiger Memorial Stadium, while easy access to Lowe's and The Home Depot enhances your living experience.",
  "property_home_reviews_blurb": "At Redbud Ranch in Broken Arrow, our residents love calling this community home. With prompt maintenance and a caring team, it's no wonder one happy resident exclaimed, \"I love living here; it's overall my favorite.\" Join us and experience why our apartments stand out—read more about our residents' stories today!",
  "property_neighborhood_blurb": "At Redbud Ranch in Broken Arrow, Oklahoma, you’re just steps away from a vibrant community filled with engaging parks, educational institutions like TCC Southeast and Northeastern State University, and recreational spots such as the Rose District Splash Pad and Battle Creek Golf Club. Uncover the local treasures that make life here delightful!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Redbud Ranch in Broken Arrow, Oklahoma, enjoy spacious one, two, and three-bedroom floor plans paired with extraordinary amenities. Dive into relaxation at our sparkling pool, energize in the fitness center, or unwind in our picturesque courtyard. Elevate your lifestyle—experience community living like never before!",
  "property_applynow_blurb": "At Redbud Ranch in Broken Arrow, Oklahoma, we offer a variety of spacious floor plans tailor-made for your lifestyle. Enjoy premium amenities like a sparkling pool, state-of-the-art fitness center, and relaxing spa—all within a gated community. Embrace upscale living and lease your new home online today!",
  "property_contactus_blurb": "At Redbud Ranch in Broken Arrow, Oklahoma, our thoughtfully designed one, two, and three-bedroom floor plans cater to your unique lifestyle. Whether you crave cozy nights or spacious gatherings, you’ll find the perfect fit here. Have questions? Contact our leasing team today and let’s make your dream home a reality!",
  "property_faqs_blurb": "At Redbud Ranch in Broken Arrow, Oklahoma, we offer a variety of thoughtfully designed floor plans, including one, two, and three-bedroom options. Have questions about our vibrant community? Browse our FAQs page for insights that matter, and find the perfect home that suits your lifestyle.",
  "property_floorplans_blurb": "At Redbud Ranch in Broken Arrow, Oklahoma, a variety of thoughtfully designed floor plans await you. Choose from cozy one-bedroom retreats, spacious two-bedroom havens, or expansive three-bedroom residences. Each home invites comfort and style. Browse our available apartment homes today to find the perfect fit for your lifestyle!",
  "property_gallery_blurb": "At Redbud Ranch in Broken Arrow, Oklahoma, vibrant living comes alive! Choose from spacious one, two, or three-bedroom floor plans, each designed for comfort. Enjoy premium amenities, including a refreshing pool, a state-of-the-art fitness center, and a lively gameroom. Picture yourself thriving in this dynamic community!",
  "property_interactivemap_blurb": "Welcome to Redbud Ranch in Broken Arrow, Oklahoma, where comfort meets convenience. Whether you seek a cozy one-bedroom or a spacious three-bedroom, our vibrant community boasts amenities like a refreshing pool, a state-of-the-art fitness center, and a pet-friendly play area. Use our interactive map to explore your future home!",
  "property_pets_blurb": "At Redbud Ranch in Broken Arrow, OK, your pets are part of the family! With a generous 80lbs weight limit, furry friends can roam our scenic grounds. Experience the perfect blend of comfort and community, where home feels welcoming for both you and your four-legged companions. Relax and enjoy!",
  "property_referafriend_blurb": "At Redbud Ranch in Broken Arrow, Oklahoma, a vibrant community awaits with one, two, and three-bedroom floor plans tailored for every lifestyle. Share the joy of living here—refer a friend today and cultivate a neighborhood where great friends become great neighbors! Your next adventure starts right at your doorstep.",
  "property_residentaccess_blurb": "Welcome to Redbud Ranch in Broken Arrow, Oklahoma, where comfort meets convenience. Choose from stylish one, two, or three-bedroom floor plans tailored to your lifestyle. Access your resident portal effortlessly to pay rent, schedule maintenance, and enjoy seamless living in our vibrant community—your home awaits!",
  "property_reviews_blurb": "At Redbud Ranch in Broken Arrow, residents appreciate our responsive maintenance team and welcoming atmosphere. One tenant proudly shares, “I love living here; it's overall my favorite.” With a convenient online rent payment system and the ability to customize your living space, you'll find comfort and community in every corner.",
  "property_created_at": "1753982390607",
  "property_scheduletour_blurb": "At Redbud Ranch in Broken Arrow, Oklahoma, our thoughtfully designed one, two, and three-bedroom floor plans cater to diverse lifestyles. Experience vibrant community living and unmatched comfort—don’t just take our word for it! Schedule a tour today and hear firsthand what our residents love about calling Redbud Ranch home.",
  "property_thankyou_blurb": "Thank you for reaching out! At Redbud Ranch in Broken Arrow, Oklahoma, we offer thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. Your journey to comfortable living starts here, and our team will be in touch soon to assist you further! ",
  "property_virtualtours_blurb": "Welcome to Redbud Ranch in Broken Arrow, Oklahoma, where comfort meets charm. Choose from spacious one, two, or three-bedroom floor plans designed for modern living. Experience your future home today—take a virtual tour of our vibrant community and discover the perfect space for your lifestyle!",
  "property_copyright": "2025 All Rights Reserved. Redbud Ranch",
  "property_seo_title_home": "Redbud Ranch |  Apartments in Broken Arrow, Oklahoma",
  "property_seo_description_home": "Welcome to Redbud Ranch in Broken Arrow! Enjoy stylish floor plans, top-notch amenities, and a pet-friendly vibe. Your perfect home awaits—start living today!",
  "property_seo_title_floorplans": "Floor Plans | Broken Arrow, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Unveil your ideal home at Redbud Ranch in Broken Arrow! From cozy one-bedrooms to spacious three-bedrooms, browse our diverse floor plans today.",
  "property_seo_title_amenities": "Amenities | Broken Arrow, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Discover vibrant living at Redbud Ranch, Broken Arrow! Enjoy luxe amenities like a pool, gym, dog park, and spacious floor plans. Your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Broken Arrow, Oklahoma",
  "property_seo_description_gallery": "Unwind at Redbud Ranch in Broken Arrow! Discover stunning amenities, spacious layouts, and a welcoming vibe in our photo gallery.",
  "property_seo_title_virtualtours": "Virtual Tours | Redbud Ranch Apartments",
  "property_seo_description_virtualtours": "Experience Redbud Ranch in Broken Arrow! Take a virtual tour of our stunning one, two, and three-bedroom apartments. Your dream home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Redbud Ranch Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Redbud Ranch in Broken Arrow! Use our interactive map to explore spacious floor plans, amenities, and pricing today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Broken Arrow, Oklahoma",
  "property_seo_description_neighborhood": "Discover Redbud Ranch in Broken Arrow—a lively neighborhood with local favorites and unique gems that make our community special!",
  "property_seo_title_contact": "Contact Us | Redbud Ranch",
  "property_seo_description_contact": "Reach out to the friendly team at Redbud Ranch in Broken Arrow, OK. Inquire about our one, two, or three-bedroom apartments today! Your new home awaits.",
  "property_seo_title_faqs": "FAQs | Apartments in Broken Arrow, Oklahoma",
  "property_seo_description_faqs": "Get the answers you need about Redbud Ranch in Broken Arrow! Our FAQs cover everything from amenities to floor plans for your perfect living experience.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Broken Arrow, Oklahoma",
  "property_seo_description_reviews": "Experience life at Redbud Ranch in Broken Arrow! Our residents share their stories of luxury living with top-notch amenities and spacious floor plans. Join us!",
  "property_seo_title_applynow": "Apply Now | Apartments in Broken Arrow, Oklahoma",
  "property_seo_description_applynow": "Elevate your lifestyle at Redbud Ranch in Broken Arrow! Choose from various floor plans and enjoy amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Redbud Ranch",
  "property_seo_description_residentaccess": "Welcome to Redbud Ranch in Broken Arrow, OK! Log in to your resident portal for rent payments, maintenance requests, and seamless community living.",
  "property_seo_title_referafriend": "Refer A Friend | Redbud Ranch",
  "property_seo_description_referafriend": "Refer a friend to Redbud Ranch and help them find their perfect home in Broken Arrow—where great friends make great neighbors!",
  "property_seo_title_scheduletour": "Schedule a Tour | Redbud Ranch",
  "property_seo_description_scheduletour": "Experience the charm of Redbud Ranch in Broken Arrow. Schedule your tour today and envision your new life in a vibrant community that feels like home!",
  "property_seo_title_privacy": "Privacy Policy | Redbud Ranch",
  "property_seo_description_privacy": "At Redbud Ranch in Broken Arrow, your privacy matters. Uncover our commitment to safeguarding your personal information and enjoy peace of mind. Read more!",
  "property_seo_title_accessibility": "Website Accessibility | Redbud Ranch",
  "property_seo_description_accessibility": "At Redbud Ranch in Broken Arrow, we prioritize accessibility and inclusivity—everyone deserves a comfortable place to call home.",
  "property_seo_title_sitemap": "Sitemap | Redbud Ranch",
  "property_seo_description_sitemap": "Unveiling the heart of Redbud Ranch in Broken Arrow, OK! Navigate our sitemap for a seamless tour of amenities, floor plans, and community highlights.",
  "property_seo_title_thankyou": "Thank You | Redbud Ranch",
  "property_seo_description_thankyou": "Thank you for reaching out! Your next chapter at Redbud Ranch is near. Our team will connect soon for personalized assistance.",
  "property_seo_title_pets": "Pet Policy | Apartments in Broken Arrow, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865667949",
  "amenities": [
    {
      "id": "ec_e897eec54364a11990659c01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127397037",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7bed976072f55f274acb9df4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127397038",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e2fa2ea8866b4de7a3485dd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127397039",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f6c376605a464b50085a8fe6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127397040",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_523d2c18ee846997a825cfa8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127397041",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f762324ddab230d01a6b6ee2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127397042",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_86074ebc61d5dc42eb4275c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127397043",
      "title": "Media Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e81d135b7cacc91a2af1eb9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127397045",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_89b25997949c7ecfcb26a98a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "128033180",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8527feaa5bcd2dde5ad813a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127397047",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78efc38d781a8abea6c8e6aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "128042549",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_96c47e0471f14a7041ba2921",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127397048",
      "title": "Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bdb54401a1afa27b806031bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127398503",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f9a28bf4ef98299a2b39acf1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127398504",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_147b3d9dd4ebd50c4bf8542b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127398505",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ee3cec8267effe1745da462",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127398506",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cd51b8f41d76a8edd07ccc31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127398507",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1bdac0db79113bc2a68bd23f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127398508",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0e4526911540e0f80a9983c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127398509",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9058ec6460b3090c22dce1fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127398510",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa3ca45dff9171554cb3a0cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127398511",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a635d712a3233eae94455f80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127398512",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3a27d9734a9d38803419c04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "yardi",
      "external_id": "127398513",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_a5d3a7b0-bbac-4542-a6ac-7b30831c258b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa538-9048-749a-a423-ea63c24d49a9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and a marble island.",
        "public_id": "019fa538-9048-749a-a423-ea63c24d49a9",
        "storage_key": "property/6767906449165623/019fa538-9048-749a-a423-ea63c24d49a9.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Experience culinary delights in this fully equipped kitchen, featuring stainless steel appliances, ample cabinet space, and a sleek marble countertop island.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and a marble island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4f64e2bf-2f7c-415b-831c-8ea13f87d087",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa538-9304-74e9-8c70-927ca24c87d4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, white subway tile backsplash, and marble countertops.",
        "public_id": "019fa538-9304-74e9-8c70-927ca24c87d4",
        "storage_key": "property/6767906449165623/019fa538-9304-74e9-8c70-927ca24c87d4.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Fully equipped modern kitchen featuring stainless steel appliances, elegant dark wood cabinetry, a classic white subway tile backsplash, and luxurious marble countertops.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, white subway tile backsplash, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_caf819fe-4bb8-494e-bb39-3c60edfdd9cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa538-9bc0-7686-800f-50244298c0a1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and white subway tile backsplash.",
        "public_id": "019fa538-9bc0-7686-800f-50244298c0a1",
        "storage_key": "property/6767906449165623/019fa538-9bc0-7686-800f-50244298c0a1.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring dark wood cabinetry, sleek stainless steel appliances, and a stylish white subway tile backsplash. Perfect for preparing meals.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and white subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8f5b0151-c7c5-4b0e-b575-5453fece878d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa538-7fad-701e-8b2d-974efdbfb667.webp",
      "image_media": {
        "alt_text": "A desk with a chair, books, and a lamp in a well-lit apartment living area.",
        "public_id": "019fa538-7fad-701e-8b2d-974efdbfb667",
        "storage_key": "property/6767906449165623/019fa538-7fad-701e-8b2d-974efdbfb667.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Create a comfortable and productive workspace in your apartment with this elegant desk setup, featuring a chair, a lamp, and decorative books.",
      "link": "",
      "alt_text": "A desk with a chair, books, and a lamp in a well-lit apartment living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0274e203-1948-49ac-9d94-c929333624ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa538-7970-7098-a752-4b31892a713d.webp",
      "image_media": {
        "alt_text": "A dining table with four chairs, a desk, and a large window.",
        "public_id": "019fa538-7970-7098-a752-4b31892a713d",
        "storage_key": "property/6767906449165623/019fa538-7970-7098-a752-4b31892a713d.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "A stylish dining area with plush seating and ample natural light, perfect for meals or a quiet workspace.",
      "link": "",
      "alt_text": "A dining table with four chairs, a desk, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e361f3eb-c1cc-4cd1-a000-7f7b6d3276fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa538-61a5-75af-b436-ec28e7f0da5d.webp",
      "image_media": {
        "alt_text": "Modern living room with a sectional sofa, coffee table, and dining area.",
        "public_id": "019fa538-61a5-75af-b436-ec28e7f0da5d",
        "storage_key": "property/6767906449165623/019fa538-61a5-75af-b436-ec28e7f0da5d.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully appointed apartment, featuring a spacious living area and adjacent dining space perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room with a sectional sofa, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c1898c5e-4ab8-489f-87a2-9a62243a46ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa538-60eb-7356-9689-7f75a4fa1df8.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, navy blue bedding, decorative pillows, and a dresser.",
        "public_id": "019fa538-60eb-7356-9689-7f75a4fa1df8",
        "storage_key": "property/6767906449165623/019fa538-60eb-7356-9689-7f75a4fa1df8.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Relax in comfort in our beautifully appointed bedrooms, featuring plush bedding and elegant decor.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, navy blue bedding, decorative pillows, and a dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5b4ee792-e5bf-4d4a-ad99-9b58699b10b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa538-5004-7279-b3de-e2f7d319a9ed.webp",
      "image_media": {
        "alt_text": "Queen-size bed with navy blue bedding and decorative pillows in a well-lit bedroom.",
        "public_id": "019fa538-5004-7279-b3de-e2f7d319a9ed",
        "storage_key": "property/6767906449165623/019fa538-5004-7279-b3de-e2f7d319a9ed.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a queen-size bed with plush navy blue bedding and elegant decorative pillows.",
      "link": "",
      "alt_text": "Queen-size bed with navy blue bedding and decorative pillows in a well-lit bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a2a27117-2896-40a0-a2a2-d216fff5cb99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa538-4fb1-7423-948f-71c884a20533.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with a white sink and dark wood cabinets, a toilet, and decorative bird art.",
        "public_id": "019fa538-4fb1-7423-948f-71c884a20533",
        "storage_key": "property/6767906449165623/019fa538-4fb1-7423-948f-71c884a20533.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Stylish bathroom featuring a modern vanity with a white sink, dark wood cabinets, and elegant marble countertops. The space is complemented by decorative bird artwork and a crisp white toilet.",
      "link": "",
      "alt_text": "Bathroom vanity with a white sink and dark wood cabinets, a toilet, and decorative bird art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ba3ea9af-19b4-4cc0-920c-4e6fa7bcc3f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa538-4f82-764d-b826-e53a792f3a03.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with marble countertop, sink, and decorative artwork.",
        "public_id": "019fa538-4f82-764d-b826-e53a792f3a03",
        "storage_key": "property/6767906449165623/019fa538-4f82-764d-b826-e53a792f3a03.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Modern bathroom vanity featuring a marble countertop, stainless steel faucet, and tasteful artwork.",
      "link": "",
      "alt_text": "Bathroom vanity with marble countertop, sink, and decorative artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_98b176df-30ad-4a31-9ba1-2606a934d0dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa538-4f11-75dd-a8bd-2b1b286e1421.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white tub, shower with blue curtain, vanity with marble countertop and sink, and decorative wall art.",
        "public_id": "019fa538-4f11-75dd-a8bd-2b1b286e1421",
        "storage_key": "property/6767906449165623/019fa538-4f11-75dd-a8bd-2b1b286e1421.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a soaking tub, modern vanity with a marble countertop, and stylish decorative accents for a spa-like feel.",
      "link": "",
      "alt_text": "Modern bathroom with a white tub, shower with blue curtain, vanity with marble countertop and sink, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_583b7d26-dd31-409b-ba72-7cc933e9f5c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa537-8ea9-7737-a76e-18856446a29f.webp",
      "image_media": {
        "alt_text": "Spacious and modern apartment community lounge with fireplace and seating.",
        "public_id": "019fa537-8ea9-7737-a76e-18856446a29f",
        "storage_key": "property/6767906449165623/019fa537-8ea9-7737-a76e-18856446a29f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring a cozy fireplace and comfortable seating areas. Perfect for socializing or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Spacious and modern apartment community lounge with fireplace and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1f9fcc92-2c80-4eed-965e-dc2689633180",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa537-80a6-72af-bd65-0ab9992b2c3e.webp",
      "image_media": {
        "alt_text": "Redbud Ranch Apartments common area with pool table, TVs, and seating.",
        "public_id": "019fa537-80a6-72af-bd65-0ab9992b2c3e",
        "storage_key": "property/6767906449165623/019fa537-80a6-72af-bd65-0ab9992b2c3e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the resident lounge at Redbud Ranch Apartments, featuring a pool table, multiple televisions, and comfortable seating areas.",
      "link": "",
      "alt_text": "Redbud Ranch Apartments common area with pool table, TVs, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ae053bbe-229a-4a44-840d-fed2ad21cae0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa537-8046-76fd-aef0-85f5df7a6a1c.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern multifamily property's clubhouse and parking lot.",
        "public_id": "019fa537-8046-76fd-aef0-85f5df7a6a1c",
        "storage_key": "property/6767906449165623/019fa537-8046-76fd-aef0-85f5df7a6a1c.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Modern clubhouse exterior with welcoming entrance and ample parking, reflecting the community's amenities.",
      "link": "",
      "alt_text": "Exterior view of a modern multifamily property's clubhouse and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2a43bd78-ec51-4baf-9905-d045f092013e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa537-7871-721b-a226-9b01e130ff89.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, and a weight bench.",
        "public_id": "019fa537-7871-721b-a226-9b01e130ff89",
        "storage_key": "property/6767906449165623/019fa537-7871-721b-a226-9b01e130ff89.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment and free weights, perfect for maintaining your workout routine.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, and a weight bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e03583f0-6245-4097-a62f-d1059158f0b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa537-74fc-70c3-b6bf-90dbf75c6458.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with parking lot and signage.",
        "public_id": "019fa537-74fc-70c3-b6bf-90dbf75c6458",
        "storage_key": "property/6767906449165623/019fa537-74fc-70c3-b6bf-90dbf75c6458.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Exterior view of modern apartment building with brick facade, balconies, and surrounding grounds.",
      "link": "",
      "alt_text": "Exterior of apartment building with parking lot and signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_059fc6ae-f80a-4b82-94ad-a717e90ab5ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa537-7a77-7611-bdf8-1edd9c373359.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019fa537-7a77-7611-bdf8-1edd9c373359",
        "storage_key": "property/6767906449165623/019fa537-7a77-7611-bdf8-1edd9c373359.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool, perfect for relaxing and soaking up the sun. This amenity is surrounded by modern apartment buildings and lush landscaping.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8b8cdb3c-e6d5-4c8d-b8d6-a4b7e163c8b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa537-7773-7183-83b4-3409d2312cf2.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with brick and white siding, balconies, and green lawn.",
        "public_id": "019fa537-7773-7183-83b4-3409d2312cf2",
        "storage_key": "property/6767906449165623/019fa537-7773-7183-83b4-3409d2312cf2.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Exterior view of a multi-story apartment building featuring a mix of brick and white siding, private balconies, and well-maintained landscaping. \"Now Leasing\" signage is visible.",
      "link": "",
      "alt_text": "Modern apartment building exterior with brick and white siding, balconies, and green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b18bc00-7da4-4e3c-93b7-3168de95dea2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa537-73e8-72c8-951f-21bae753113e.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with outdoor seating and fire pit.",
        "public_id": "019fa537-73e8-72c8-951f-21bae753113e",
        "storage_key": "property/6767906449165623/019fa537-73e8-72c8-951f-21bae753113e.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Relax by the fire pit or enjoy the outdoors with comfortable seating. This community amenity offers a perfect spot for socializing and unwinding.",
      "link": "",
      "alt_text": "Modern apartment building exterior with outdoor seating and fire pit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3b19e63c-6f5b-4c74-8f2a-d6089b409a1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa537-5a4d-712d-ae02-9ccd5a74fbb1.webp",
      "image_media": {
        "alt_text": "Beautifully staged bedroom with a queen-size bed, dresser, and ceiling fan.",
        "public_id": "019fa537-5a4d-712d-ae02-9ccd5a74fbb1",
        "storage_key": "property/6767906449165623/019fa537-5a4d-712d-ae02-9ccd5a74fbb1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully staged bedroom, complete with a plush queen-size bed, ample dresser storage, and a ceiling fan for added comfort.",
      "link": "",
      "alt_text": "Beautifully staged bedroom with a queen-size bed, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_990f0516-37ce-4b8b-8ed6-712bfd12ab06",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa537-5a51-7326-a5a9-50d3e30ec87d.webp",
      "image_media": {
        "alt_text": "Modern gray kitchen with stainless steel appliances and marble countertops.",
        "public_id": "019fa537-5a51-7326-a5a9-50d3e30ec87d",
        "storage_key": "property/6767906449165623/019fa537-5a51-7326-a5a9-50d3e30ec87d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring gray cabinetry, stainless steel appliances, and elegant marble countertops, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern gray kitchen with stainless steel appliances and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6637511b-f8b4-412a-9d77-1ddd626c381b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa537-4ec2-711b-84a7-399100d9d43b.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with bar seating, featuring a leather sofa, dining table, and a large art piece.",
        "public_id": "019fa537-4ec2-711b-84a7-399100d9d43b",
        "storage_key": "property/6767906449165623/019fa537-4ec2-711b-84a7-399100d9d43b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed living space. This open-concept apartment features a modern kitchen with bar seating, a cozy living area perfect for relaxation, and elegant dining space.",
      "link": "",
      "alt_text": "Living room and kitchen area with bar seating, featuring a leather sofa, dining table, and a large art piece.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2b70dfba-d1aa-473a-a9f5-bdd59d7d124b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa537-5b95-74a5-9281-c70d407e6256.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, toilet, vanity, and sink.",
        "public_id": "019fa537-5b95-74a5-9281-c70d407e6256",
        "storage_key": "property/6767906449165623/019fa537-5b95-74a5-9281-c70d407e6256.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the modern amenities in this beautifully appointed bathroom, featuring a spacious bathtub and a stylish vanity with a marble countertop.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, toilet, vanity, and sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c3603501-1f04-4d6d-911b-35286fee4bec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa537-4ded-7009-8593-f74a611eee87.webp",
      "image_media": {
        "alt_text": "Living room and dining area with plush seating, modern decor, and large windows.",
        "public_id": "019fa537-4ded-7009-8593-f74a611eee87",
        "storage_key": "property/6767906449165623/019fa537-4ded-7009-8593-f74a611eee87.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring comfortable seating, elegant decor, and ample natural light from large windows.",
      "link": "",
      "alt_text": "Living room and dining area with plush seating, modern decor, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2dc9d5ed-c7ec-473f-aaa4-d54210362e4a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa537-37ac-703b-9885-374739de6be4.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and modern clubhouse on a sunny day.",
        "public_id": "019fa537-37ac-703b-9885-374739de6be4",
        "storage_key": "property/6767906449165623/019fa537-37ac-703b-9885-374739de6be4.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool or unwind at the modern clubhouse, offering the perfect amenities for a luxurious lifestyle.",
      "link": "",
      "alt_text": "Outdoor swimming pool and modern clubhouse on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c99d366e-8faf-4e42-849a-0dfcebc2e2d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa537-376a-74f8-ad15-cf6c6deda694.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with shower.",
        "public_id": "019fa537-376a-74f8-ad15-cf6c6deda694",
        "storage_key": "property/6767906449165623/019fa537-376a-74f8-ad15-cf6c6deda694.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and modern apartment bathroom featuring a marble-look vanity, toilet, and a bathtub with a white tile shower surround.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c1df722-63c0-43f9-86be-087d7d08a821",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019fa537-357d-729a-a2f4-d86773fc3559.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light gray cabinets, marble countertops, stainless steel refrigerator, and breakfast bar with two seating stools.",
        "public_id": "019fa537-357d-729a-a2f4-d86773fc3559",
        "storage_key": "property/6767906449165623/019fa537-357d-729a-a2f4-d86773fc3559.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this stylish kitchen, perfect for home chefs and entertainers. Featuring sleek light gray cabinetry, elegant marble countertops, and a convenient breakfast bar with seating.",
      "link": "",
      "alt_text": "Modern kitchen with light gray cabinets, marble countertops, stainless steel refrigerator, and breakfast bar with two seating stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_08d27395-411a-4180-aa49-f28440bbb541",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "11111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain steakhouse known for its hand-cut steaks, ribs, and made-from-scratch sides.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and filet medallions, and their rolls with cinnamon butter are a highlight. They also highlight the affordable prices, fun atmosphere, and attentive service.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-8a52-713c-a23b-df0b80bb98c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-8a52-713c-a23b-df0b80bb98c2",
        "storage_key": "property/6767906449165623/019cfb46-8a52-713c-a23b-df0b80bb98c2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-east-71st-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669544637791228065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0613876",
      "poi_longitude": "-95.852648",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-461-8891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a28b-70ae-b6b8-8e352bd6fccd",
        "storage_key": "property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dEXckyMtocRoVC4glHWEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_8ec54435-0f32-4f65-9ea3-7093c6b23dea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10708 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly national chain serving classic American comfort foods, plus cocktails, beer and steaks.",
      "poi_long_description": "Diners say this traditional US American restaurant serves up delicious honey butter croissants, salmon, and steak. They also highlight the friendly and attentive service, reasonable prices, and generous portions.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-8a51-757f-a9d6-36bcb0c8b079.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-8a51-757f-a9d6-36bcb0c8b079",
        "storage_key": "property/6767906449165623/019cfb46-8a51-757f-a9d6-36bcb0c8b079.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cheddars.com/locations/ok/tulsa/tulsa/2015?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:tulsa-ok-2015_pl:locurl_rd:1010",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101010613821228024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "36.06025",
      "poi_longitude": "-95.85707",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-307-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a28b-70ae-b6b8-8e352bd6fccd",
        "storage_key": "property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6XrprSNtocR-MOnbFa2Dpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_1bbe7c2a-6aa6-4124-a02b-94261a89361d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "1100 N 9th St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Laid-back chain counter-service spot specializing in hand-battered fried chicken tenders, fries and Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves crispy chicken fingers, Texas toast, and fries. They highlight the tasty dipping sauce and the fresh, hot food. They also like the friendly staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-8a32-71b8-86ee-65a0f685e924.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-8a32-71b8-86ee-65a0f685e924",
        "storage_key": "property/6767906449165623/019cfb46-8a32-71b8-86ee-65a0f685e924.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/broken-arrow/1100-n.-9th-st.",
      "poi_directions_map_url": "https://maps.google.com/?cid=6389543638470134900&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.0621208",
      "poi_longitude": "-95.7802036",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-259-0213",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a28b-70ae-b6b8-8e352bd6fccd",
        "storage_key": "property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLT-hA7eLtocRdIze_xU4rFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_0718b121-82a6-4eef-911a-0608e49284a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "11201 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Counter-serve, kid-friendly chain serving chicken sandwiches, salads and fries amid casual surroundings.",
      "poi_long_description": "People say this fast food restaurant offers a large, fresh Southwest Salad with grilled chicken and a tasty Creamy Salsa dressing. They highlight the salad is a great low-carb choice. They also like the fast service, especially through the drive-thru.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-8a1d-764d-bc64-a399c2ff132a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-8a1d-764d-bc64-a399c2ff132a",
        "storage_key": "property/6767906449165623/019cfb46-8a1d-764d-bc64-a399c2ff132a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/eastside-market?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13877322036504863520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.061357",
      "poi_longitude": "-95.852101",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-461-0777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a28b-70ae-b6b8-8e352bd6fccd",
        "storage_key": "property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE_NPDkyMtocRIKOS890mlsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_8d7bc1c0-02ad-4b53-be14-16a65c3c954c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Los Cabos Mexican Grill and Cantina",
      "poi_type": "Restaurants",
      "poi_address": "151 Bass Pro Drive, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Traditional Mexican, Tex-Mex, and coastal fare are served at this comfy eatery with a bar, patio, and live entertainment.",
      "poi_long_description": "People say this Mexican restaurant serves delicious fried avocados, steak fajitas, and queso. They also highlight the fast and friendly service, the beautiful patio with live music, and the fun atmosphere.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-8a45-7059-ae90-2b8c8f0c379f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-8a45-7059-ae90-2b8c8f0c379f",
        "storage_key": "property/6767906449165623/019cfb46-8a45-7059-ae90-2b8c8f0c379f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.loscabosok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18102787138540067868&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "los-cabos-mexican-grill-and-cantina",
      "poi_latitude": "36.0700999",
      "poi_longitude": "-95.7904175",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-355-8877",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a28b-70ae-b6b8-8e352bd6fccd",
        "storage_key": "property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJafMyIaOLtocRHNwwZf0EOvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_f249865f-dabf-4356-a0bc-e9b95cb4c3c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Pan-Asia Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "10003 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Asian grocery store featuring fresh produce and seafood. Also on offer: sushi and tea.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh produce, live seafood, and Asian groceries, including a large selection of meats, spices, and noodles. They highlight the fair prices, the clean and organized store, and the delicious hot food, boba tea, and sushi available at the cafe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-8a69-754b-9788-7f9f0dd524b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-8a69-754b-9788-7f9f0dd524b0",
        "storage_key": "property/6767906449165623/019cfb46-8a69-754b-9788-7f9f0dd524b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.panasiasupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1484729550679765321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pan-asia-supermarket",
      "poi_latitude": "36.0630212",
      "poi_longitude": "-95.8655271",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-940-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a299-7199-8d9d-638a4b10273d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a299-7199-8d9d-638a4b10273d",
        "storage_key": "property/6767906449165623/019cfb46-a299-7199-8d9d-638a4b10273d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1gpIX6NtocRSfHK76jRmhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_85630148-bb97-498c-a1c4-cc276e93956f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1900 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store has a wide variety of products and helpful staff. They also highlight the convenient self-checkout option.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-89dc-724f-a167-3031ed8309e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-89dc-724f-a167-3031ed8309e7",
        "storage_key": "property/6767906449165623/019cfb46-89dc-724f-a167-3031ed8309e7.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Broken-Arrow/1536?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1536-_-na-_-0-_-0&y_source=1_MTE4NDM5OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12318214238171197715&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "36.065158",
      "poi_longitude": "-95.767607",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-355-4926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2af-75eb-86ef-cd315a63dfdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2af-75eb-86ef-cd315a63dfdb",
        "storage_key": "property/6767906449165623/019cfb46-a2af-75eb-86ef-cd315a63dfdb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJg5dy-UuKtocRE3FavZUW86o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_4401ba55-eb80-4e20-9a9e-182f8e4e8be6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "9808 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain retail outlet for home improvement items, from tools and paint to lumber and garden supplies.",
      "poi_long_description": "People say this home improvement store has helpful and friendly staff who are knowledgeable about their areas. They also highlight the well-stocked store and efficient delivery service.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-89dc-724f-a167-353d0943dc66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-89dc-724f-a167-353d0943dc66",
        "storage_key": "property/6767906449165623/019cfb46-89dc-724f-a167-353d0943dc66.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/South-Tulsa/OK/Tulsa/74133/3903?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1237148003252488434&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "36.0595916",
      "poi_longitude": "-95.866433",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-459-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2af-75eb-86ef-cd315a63dfdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2af-75eb-86ef-cd315a63dfdb",
        "storage_key": "property/6767906449165623/019cfb46-a2af-75eb-86ef-cd315a63dfdb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvaH1r7CNtocR8shy5I07KxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_26e49f21-1d9e-4481-b33b-f8d915fa4407",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Supermercados Morelos Garnett",
      "poi_type": "Shopping & Retail",
      "poi_address": "2119 S Garnett Rd, Tulsa, OK 74129, USA",
      "poi_short_description": "Mexican store featuring fresh produce, groceries and meats.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-8a44-778e-9db1-22dcaa254f32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-8a44-778e-9db1-22dcaa254f32",
        "storage_key": "property/6767906449165623/019cfb46-8a44-778e-9db1-22dcaa254f32.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.supermercadosmorelos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2140742583959097995&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "supermercados-morelos-garnett",
      "poi_latitude": "36.1319778",
      "poi_longitude": "-95.8500682",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 539-235-0319",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a299-7199-8d9d-638a4b10273d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a299-7199-8d9d-638a4b10273d",
        "storage_key": "property/6767906449165623/019cfb46-a299-7199-8d9d-638a4b10273d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOZEP_SXztocRixJvuAlytR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_94462c13-2d91-4147-8ac3-164afb2799da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "At Home",
      "poi_type": "Shopping & Retail",
      "poi_address": "11015 E 51st St, Tulsa, OK 74146, USA",
      "poi_short_description": "Large retail chain stocking a wide selection of home decor, bedding, furniture, seasonal goods, and outdoor supplies.",
      "poi_long_description": "People say this home goods store offers a wide variety of home decor, furniture, rugs, and kitchenware. They also highlight the inexpensive prices, fun selection, and soft blankets.\n\nOther reviews mention the store can be disorganized.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-8a14-7704-a939-782cf82b5767.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-8a14-7704-a939-782cf82b5767",
        "storage_key": "property/6767906449165623/019cfb46-8a14-7704-a939-782cf82b5767.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.athome.com/store/oklahoma-tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6417975247905836722&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "at-home",
      "poi_latitude": "36.09085",
      "poi_longitude": "-95.854515",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-660-0543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2af-75eb-86ef-cd315a63dfdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2af-75eb-86ef-cd315a63dfdb",
        "storage_key": "property/6767906449165623/019cfb46-a2af-75eb-86ef-cd315a63dfdb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJeT6Hq-OMtocRsk6t7Hs6EVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_caefd92d-bc9b-448c-91dd-ba331f87b01c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Tulsa Community College Southeast Campus",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9068-74f3-9533-6edc3b51e5be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9068-74f3-9533-6edc3b51e5be",
        "storage_key": "property/6767906449165623/019cfb46-9068-74f3-9533-6edc3b51e5be.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8389070837534418764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-southeast-campus",
      "poi_latitude": "36.0448034",
      "poi_longitude": "-95.8624934",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2a4-7679-8e66-95c3fce71710.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2a4-7679-8e66-95c3fce71710",
        "storage_key": "property/6767906449165623/019cfb46-a2a4-7679-8e66-95c3fce71710.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1olEM6NtocRTOfTwnr3a3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_01c0c795-0174-41fc-a230-606084a2ede9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Northeastern State University Broken Arrow",
      "poi_type": "Education",
      "poi_address": "3100 New Orleans St, Broken Arrow, OK 74014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-8f1e-765a-88ac-dd413f705dcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-8f1e-765a-88ac-dd413f705dcd",
        "storage_key": "property/6767906449165623/019cfb46-8f1e-765a-88ac-dd413f705dcd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nsuok.edu/BrokenArrow.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3996275873980647977&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northeastern-state-university-broken-arrow",
      "poi_latitude": "36.019376",
      "poi_longitude": "-95.7485342",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-449-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2a4-7679-8e66-95c3fce71710.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2a4-7679-8e66-95c3fce71710",
        "storage_key": "property/6767906449165623/019cfb46-a2a4-7679-8e66-95c3fce71710.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6bWtJw_7yYcRKYoU9bufdTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e73ab9f4-d056-48e8-80b8-126049aa85bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Martin Regional Library",
      "poi_type": "Education",
      "poi_address": "2601 S Garnett Rd, Tulsa, OK 74129, USA",
      "poi_short_description": "Public library with a range of services, including faxing, computers, and meetings, plus Vietnamese books.",
      "poi_long_description": "People say this public library offers a wide selection of books, comfortable seating, and convenient printing services. They highlight the quiet atmosphere, helpful staff, and friendly librarians. They also like the charging stations and the monthly vegan potluck. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-8eaf-72a3-bdea-40e352a8ab4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-8eaf-72a3-bdea-40e352a8ab4c",
        "storage_key": "property/6767906449165623/019cfb46-8eaf-72a3-bdea-40e352a8ab4c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tulsalibrary.org/martin/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6046822168243383481&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-regional-library",
      "poi_latitude": "36.1265968",
      "poi_longitude": "-95.8505489",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2a4-7679-8e66-95c3fce71710.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2a4-7679-8e66-95c3fce71710",
        "storage_key": "property/6767906449165623/019cfb46-a2a4-7679-8e66-95c3fce71710.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF1eFsi7ztocRuawafrmg6lM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_a73f0f0e-70ab-41a5-9b56-f6e432a1e7cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Broken Arrow Library",
      "poi_type": "Education",
      "poi_address": "300 W Broadway Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Relaxed spot featuring summer reading programs, plus helpful staff and books.",
      "poi_long_description": "People say this public library has helpful staff who can assist with checking out books, placing holds, and finding sister locations, as well as apps for readers and a pamphlet of activities and new releases. They also highlight the library's clean and cozy atmosphere with plenty of spots to sit and work or read.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-8f95-773f-84a6-0d1e872e1a77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-8f95-773f-84a6-0d1e872e1a77",
        "storage_key": "property/6767906449165623/019cfb46-8f95-773f-84a6-0d1e872e1a77.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tulsalibrary.org/brokenarrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=10472699381773494596&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "broken-arrow-library",
      "poi_latitude": "36.0529865",
      "poi_longitude": "-95.7936926",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2a4-7679-8e66-95c3fce71710.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2a4-7679-8e66-95c3fce71710",
        "storage_key": "property/6767906449165623/019cfb46-a2a4-7679-8e66-95c3fce71710.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFxNF-OmLtocRROkP2pmAVpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_8564b9f5-bc08-4c37-a254-55cea103b377",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "TCC Southeast Library",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St Building 7, Room 7200, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-909b-77ba-9085-a43bc25f2e4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-909b-77ba-9085-a43bc25f2e4e",
        "storage_key": "property/6767906449165623/019cfb46-909b-77ba-9085-a43bc25f2e4e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://library.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10341227726380407188&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tcc-southeast-library",
      "poi_latitude": "36.0433144",
      "poi_longitude": "-95.8632335",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-595-7701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2a8-77dc-b84b-85db4346a70f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2a8-77dc-b84b-85db4346a70f",
        "storage_key": "property/6767906449165623/019cfb46-a2a8-77dc-b84b-85db4346a70f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhdNrW1mNtocRlBlTtNNrg48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_a9d074c8-7ba5-4e5a-a053-40ebdb72f1c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Tiger Memorial Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1901 E Albany St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9125-753d-b98d-b2c96416f6ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9125-753d-b98d-b2c96416f6ad",
        "storage_key": "property/6767906449165623/019cfb46-9125-753d-b98d-b2c96416f6ad.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://batigersports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6374532252761582339&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tiger-memorial-stadium",
      "poi_latitude": "36.0743308",
      "poi_longitude": "-95.7632923",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-259-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-93c204f50aef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-93c204f50aef",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-93c204f50aef.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6SOplVCKtocRA-sfZ0_jdlg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_016cbb18-d74b-4fb1-802b-34d433eefe39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "The Museum Broken Arrow",
      "poi_type": "Entertainment",
      "poi_address": "400 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Small, locally focused museum highlighting the history, art and genealogy of Broken Arrow.",
      "poi_long_description": "Museum displaying local & regional history via artifacts, special exhibits & various events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-90f5-761d-be40-390ea62a2c9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-90f5-761d-be40-390ea62a2c9b",
        "storage_key": "property/6767906449165623/019cfb46-90f5-761d-be40-390ea62a2c9b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.brokenarrowmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16351764218256934691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-museum-broken-arrow",
      "poi_latitude": "36.0491954",
      "poi_longitude": "-95.7911106",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-258-2616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a299-7199-8d9d-6671445c434f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a299-7199-8d9d-6671445c434f",
        "storage_key": "property/6767906449165623/019cfb46-a299-7199-8d9d-6671445c434f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJMxSi48KLtocRI8cl0Osi7eI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_0fbc5b3c-6464-461a-8bb3-1a2ddb64519d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Rose District Splash Pad",
      "poi_type": "Entertainment",
      "poi_address": "416 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Popular destination featuring a fountain and splash pad where kids can play in the water and adults can relax.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-914f-719c-baa8-22fc719f8f86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-914f-719c-baa8-22fc719f8f86",
        "storage_key": "property/6767906449165623/019cfb46-914f-719c-baa8-22fc719f8f86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://rosedistrict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7184917167890550428&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rose-district-splash-pad",
      "poi_latitude": "36.0488437",
      "poi_longitude": "-95.7910116",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-259-7007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-8ce9e8decdcd",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0CU3cKLtocRnM64zBj0tWM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_3cfa12d4-19f8-4961-914d-34620485f149",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Military History Museum",
      "poi_type": "Entertainment",
      "poi_address": "112 N Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Tours and exhibits of military history that feature donated artifacts and memorabilia.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-90e7-700a-89fb-bc625684ce1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-90e7-700a-89fb-bc625684ce1b",
        "storage_key": "property/6767906449165623/019cfb46-90e7-700a-89fb-bc625684ce1b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.okmhc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13208418279094056410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "military-history-museum",
      "poi_latitude": "36.0528999",
      "poi_longitude": "-95.7910559",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-794-2712",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a299-7199-8d9d-6671445c434f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a299-7199-8d9d-6671445c434f",
        "storage_key": "property/6767906449165623/019cfb46-a299-7199-8d9d-6671445c434f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLetKKsKLtocR2nUtknG6Tbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_e358f875-91e3-46fa-999e-4cd5c43498db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "John Q Hammons Arena",
      "poi_type": "Entertainment",
      "poi_address": "6836 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-913b-753f-89ed-1e9fe32caafc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-913b-753f-89ed-1e9fe32caafc",
        "storage_key": "property/6767906449165623/019cfb46-913b-753f-89ed-1e9fe32caafc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8609792485950686391&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "john-q-hammons-arena",
      "poi_latitude": "36.0642162",
      "poi_longitude": "-95.8694052",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-357-7480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-8ce9e8decdcd",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJozQEI2iOtocRtwTrOqYgfHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_a387ea4b-ee3e-48bb-872b-678c86b9b10f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Crunch Fitness - Broken Arrow",
      "poi_type": "Health and Wellness",
      "poi_address": "3701 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Gym offering fitness classes, cardio equipment, and personal training, plus tanning.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and machines. They also highlight the friendly and helpful staff, and the clean and spacious facility.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9418-70af-8bbe-f013b4a9b750.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9418-70af-8bbe-f013b4a9b750",
        "storage_key": "property/6767906449165623/019cfb46-9418-70af-8bbe-f013b4a9b750.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/brokenarrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=7237271301754615382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---broken-arrow",
      "poi_latitude": "36.0152872",
      "poi_longitude": "-95.7956716",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-395-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-8ce9e8decdcd",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wtAG4WJtocRVnY2fOfzb2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a016c0f6-153e-4547-b520-f4fe05f63662",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1808 N Elm Pl, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain gym offering a variety of workout equipment, including tanning beds, in a clean environment.",
      "poi_long_description": "People say this gym offers a wide selection of equipment and is clean and well-maintained. They highlight the affordable membership and convenient location. They also like the friendly and supportive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9528-7530-9841-e1fb4533d625.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9528-7530-9841-e1fb4533d625",
        "storage_key": "property/6767906449165623/019cfb46-9528-7530-9841-e1fb4533d625.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/broken-arrow-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=8211862053813118143&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0700775",
      "poi_longitude": "-95.7999697",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-739-6224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-8ce9e8decdcd",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNfEd95mLtocRv2QKlgdl9nE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b40a6c58-92d9-41a2-ae5e-c2553f08e7b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "1800 S Aspen Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain fitness center featuring an indoor pool, walking track, and sauna, plus group classes.",
      "poi_long_description": "People say this gym offers a wide variety of machines, a pool, a sauna, and a steam room. They highlight the affordable membership price and the motivating, friendly, and clean environment. They also like the personable and caring staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9578-755b-ab82-0cf0157b609e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9578-755b-ab82-0cf0157b609e",
        "storage_key": "property/6767906449165623/019cfb46-9578-755b-ab82-0cf0157b609e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://10gym.com/broken-arrow-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11720724796821001426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.0335826",
      "poi_longitude": "-95.8157827",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-251-4855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-8ce9e8decdcd",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOe0w-qqOtocR0tSgiBphqKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0b3bfded-2024-4d4c-b073-eac048333001",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "R.C. Dickenson Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "8501 S Garnett Rd, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Classes, pool and gym with friendly staff plus a variety of exercise machines.",
      "poi_long_description": "People say this gym offers a wide variety of cardio and weightlifting equipment, as well as a play and learn area for children. They highlight the clean facilities and affordable prices. They also like the friendly and professional staff, and the calm and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9764-7319-8ff3-fa2b030b3d3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9764-7319-8ff3-fa2b030b3d3b",
        "storage_key": "property/6767906449165623/019cfb46-9764-7319-8ff3-fa2b030b3d3b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ymcatulsa.org/dickenson/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3422791293805268507&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rc-dickenson-family-ymca",
      "poi_latitude": "36.0410595",
      "poi_longitude": "-95.8496234",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-872-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-8ce9e8decdcd",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb0w56y6MtocRGw6QB4wygC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8e98a150-8d27-4095-a3b9-f7b2be4c85fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Umac Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "6836 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Gym featuring basketball and volleyball courts, plus facilities for wrestling, cheerleading, and other competitions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9764-7319-8ff3-fd8ffae3c4ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9764-7319-8ff3-fd8ffae3c4ea",
        "storage_key": "property/6767906449165623/019cfb46-9764-7319-8ff3-fd8ffae3c4ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.unionps.org/activities/umac",
      "poi_directions_map_url": "https://maps.google.com/?cid=17233318345147314712&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "umac-tulsa",
      "poi_latitude": "36.0641918",
      "poi_longitude": "-95.8694283",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-357-7480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-8ce9e8decdcd",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo05n3rqNtocRGHK6l7oLKe8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a7186a19-55ec-49cc-a829-837f506576a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Animal Emergency Center of Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "4055 S 102nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-969a-718a-a9af-d2828eb8f0cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-969a-718a-a9af-d2828eb8f0cb",
        "storage_key": "property/6767906449165623/019cfb46-969a-718a-a9af-d2828eb8f0cb.webp",
        "width": 1060,
        "height": 596
      },
      "poi_business_url": "https://aectulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5673475209959077837&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-emergency-center-of-tulsa",
      "poi_latitude": "36.1054336",
      "poi_longitude": "-95.8632907",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-665-0508",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-8ce9e8decdcd",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_xcYAlmNtocRzXeY46Q7vE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_5f7654b6-3e25-4cbe-8337-c2225ceb88e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Miami Nails",
      "poi_type": "Health and Wellness",
      "poi_address": "2409 W Kenosha St #161, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9729-770d-972c-a6cc99d41812.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9729-770d-972c-a6cc99d41812",
        "storage_key": "property/6767906449165623/019cfb46-9729-770d-972c-a6cc99d41812.webp",
        "width": 900,
        "height": 900
      },
      "poi_business_url": "https://miaminailsbrokenarrow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18392555638477026749&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "miami-nails",
      "poi_latitude": "36.0596694",
      "poi_longitude": "-95.8197326",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-251-2525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-8ce9e8decdcd",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdYxGgXSMtocRvfUHv-d7P_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_66ef9b0c-d85f-49a9-9139-188b03e9c50b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Tulsa Animal Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "6119 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9756-76ed-8695-1ded1ba8c771.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9756-76ed-8695-1ded1ba8c771",
        "storage_key": "property/6767906449165623/019cfb46-9756-76ed-8695-1ded1ba8c771.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tulsaurgentvet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6226739192106267588&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-animal-urgent-care",
      "poi_latitude": "36.074692",
      "poi_longitude": "-95.8676795",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-417-8887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-8ce9e8decdcd",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZA5V6SNtocRxDN_9k3SaVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_c60b97d6-108f-4cfd-9a3e-fcaf0fdff79c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Lush Nail Bar",
      "poi_type": "Health and Wellness",
      "poi_address": "801 E Kenosha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Salon offering manicures, pedicures, waxing, and other nail services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9869-74af-877b-7688606d3b22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9869-74af-877b-7688606d3b22",
        "storage_key": "property/6767906449165623/019cfb46-9869-74af-877b-7688606d3b22.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://lushnailbarbrokenarrow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2866933479710100417&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lush-nail-bar",
      "poi_latitude": "36.0605497",
      "poi_longitude": "-95.7812487",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-994-6399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-8ce9e8decdcd",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm7yXg2qLtocRwYvLZM9kySc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_893f3a66-651e-405a-b53c-f1b172e2bbb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Pride Gymnastics Academy",
      "poi_type": "Health and Wellness",
      "poi_address": "7801 Old Hwy 51, Broken Arrow, OK 74014, USA",
      "poi_short_description": "Center with beginner-to-advanced classes for boys and girls, and for competitive teams at various levels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9729-770d-972c-a8315978546e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9729-770d-972c-a8315978546e",
        "storage_key": "property/6767906449165623/019cfb46-9729-770d-972c-a8315978546e.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "http://www.pridegymnasticsacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2393797722264098618&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pride-gymnastics-academy",
      "poi_latitude": "36.0506679",
      "poi_longitude": "-95.7560746",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-251-7009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2a4-7679-8e66-95c3fce71710.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2a4-7679-8e66-95c3fce71710",
        "storage_key": "property/6767906449165623/019cfb46-a2a4-7679-8e66-95c3fce71710.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiyEbP6-NtocROtewc1h6OCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_155e9040-d113-48ca-9dd3-19a8ccbe45ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Council Oak Comprehensive Healthcare",
      "poi_type": "Health and Wellness",
      "poi_address": "10109 E 79th St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-99f3-71c5-8637-4cc042b85127.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-99f3-71c5-8637-4cc042b85127",
        "storage_key": "property/6767906449165623/019cfb46-99f3-71c5-8637-4cc042b85127.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.creekhealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3324838369463455816&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "council-oak-comprehensive-healthcare",
      "poi_latitude": "36.0515562",
      "poi_longitude": "-95.863328",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-233-9550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2a5-758d-a97d-688d8b0ed72f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2a5-758d-a97d-688d8b0ed72f",
        "storage_key": "property/6767906449165623/019cfb46-a2a5-758d-a97d-688d8b0ed72f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJr3-HdVONtocRSFB1m-EyJC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_946d9575-362b-4057-89f9-f6cf7138fcf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Ascension St. John Broken Arrow",
      "poi_type": "Health and Wellness",
      "poi_address": "1000 W Boise Cir, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9a03-72f4-b92f-6f26443f4fe3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9a03-72f4-b92f-6f26443f4fe3",
        "storage_key": "property/6767906449165623/019cfb46-9a03-72f4-b92f-6f26443f4fe3.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/oklahoma/oktul/broken-arrow-ascension-st-john-broken-arrow?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17632597930438221895&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-st-john-broken-arrow",
      "poi_latitude": "36.0782047",
      "poi_longitude": "-95.8008112",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-994-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2a5-758d-a97d-688d8b0ed72f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2a5-758d-a97d-688d8b0ed72f",
        "storage_key": "property/6767906449165623/019cfb46-a2a5-758d-a97d-688d8b0ed72f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJP5AVoZ2LtocRR-AOb2WSs_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e2355478-3749-436f-9173-0e8349691613",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Rhema Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a beautiful display of Christmas lights, with a light show synchronized to music. They highlight the festive and family-friendly atmosphere, and the opportunity to walk or drive through the light experience. They also like the availability of hot cocoa, popcorn, and horse-drawn carriage rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9a8e-7284-a625-73ea15929daf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9a8e-7284-a625-73ea15929daf",
        "storage_key": "property/6767906449165623/019cfb46-9a8e-7284-a625-73ea15929daf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rhemalights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7029601498986534882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rhema-park",
      "poi_latitude": "36.0599323",
      "poi_longitude": "-95.808211",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a289-7694-9648-e79069790701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a289-7694-9648-e79069790701",
        "storage_key": "property/6767906449165623/019cfb46-a289-7694-9648-e79069790701.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQLUiIyLtocR4lelo1EpjmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_55f3cae1-f0a4-43b6-9089-d5db2014490a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Elam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74011, USA",
      "poi_short_description": "Fenced park featuring picnic tables and a playground for children.",
      "poi_long_description": "People say this park offers a variety of playground equipment, including slides, swings, and a zipline, as well as picnic tables, soccer fields, and a water fountain with a bottle refill station. They highlight the park's clean bathrooms, shaded seating areas, and fenced-in playground, making it safe and enjoyable for children of all ages. They also like the park's accessible layout and thoughtful design, especially for toddlers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9b4b-7476-bfdb-20f9e3150ac1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9b4b-7476-bfdb-20f9e3150ac1",
        "storage_key": "property/6767906449165623/019cfb46-9b4b-7476-bfdb-20f9e3150ac1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brokenarrowok.gov/Home/Components/News/News/2234/15",
      "poi_directions_map_url": "https://maps.google.com/?cid=8281012522592314667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elam-park",
      "poi_latitude": "36.0062955",
      "poi_longitude": "-95.8209464",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a289-7694-9648-e79069790701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a289-7694-9648-e79069790701",
        "storage_key": "property/6767906449165623/019cfb46-a289-7694-9648-e79069790701.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_XMAgCPtocRKyWtvQMR7HI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a23e67ae-5c54-4af9-9355-bdffa48abc19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Battle Creek Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3200 N Battle Creek Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Public golf course offering multiple water challenges.",
      "poi_long_description": "Golfers say this public golf course has greens in excellent condition and is challenging without being overwhelming. They also highlight the friendly staff and reasonable rates.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9be1-772c-9d4b-11047eb93ed4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9be1-772c-9d4b-11047eb93ed4",
        "storage_key": "property/6767906449165623/019cfb46-9be1-772c-9d4b-11047eb93ed4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.battlecreekgolf.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11341802120555861489&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "battle-creek-golf-club",
      "poi_latitude": "36.0849383",
      "poi_longitude": "-95.8033736",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-355-4850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a599-70aa-8e43-819be9cd2fe1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a599-70aa-8e43-819be9cd2fe1",
        "storage_key": "property/6767906449165623/019cfb46-a599-70aa-8e43-819be9cd2fe1.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJf2pBrXCLtocR8RWB7O8sZp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_695261b3-7330-4f18-9443-41aca8cdace6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Jackson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4800 West Washington St S, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Family park offering a playground, splash pad, ponds and walking trails.",
      "poi_long_description": "Visitors say this park offers a splash pad, playground, picnic areas, walking trails, and a pond for fishing. They also highlight that the park is clean and well-maintained, with plenty of benches and a gazebo for parties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9c23-761a-ab6e-fa4c42dbc823.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9c23-761a-ab6e-fa4c42dbc823",
        "storage_key": "property/6767906449165623/019cfb46-9c23-761a-ab6e-fa4c42dbc823.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.brokenarrowok.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4376196672243292782&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jackson-park",
      "poi_latitude": "36.0328632",
      "poi_longitude": "-95.8488142",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-259-7007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a289-7694-9648-e79069790701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a289-7694-9648-e79069790701",
        "storage_key": "property/6767906449165623/019cfb46-a289-7694-9648-e79069790701.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJv3JU84KOtocRbtpO9K9fuzw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_076dc157-6a0d-4b83-bffe-44ed7da0ee53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Nienhuis Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3201 N 9th St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Large park with basketball courts and a skate park, plus a playground and a pool.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9c34-705a-8d60-015fdc567730.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9c34-705a-8d60-015fdc567730",
        "storage_key": "property/6767906449165623/019cfb46-9c34-705a-8d60-015fdc567730.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.brokenarrowok.gov/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=6651511736614571797&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nienhuis-park",
      "poi_latitude": "36.0855477",
      "poi_longitude": "-95.776939",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-259-7007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a289-7694-9648-e79069790701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a289-7694-9648-e79069790701",
        "storage_key": "property/6767906449165623/019cfb46-a289-7694-9648-e79069790701.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6GrkBaLtocRFc9A6K7qTlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e71c2f25-961e-4b54-bbf4-136bdb2743b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Harvey Young Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1419 S 135th E Ave, Tulsa, OK 74108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9c3f-713f-af20-7f9d1a6e125e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9c3f-713f-af20-7f9d1a6e125e",
        "storage_key": "property/6767906449165623/019cfb46-9c3f-713f-af20-7f9d1a6e125e.webp",
        "width": 1242,
        "height": 932
      },
      "poi_business_url": "http://harvey-young-airport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11091711320843246332&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harvey-young-airport",
      "poi_latitude": "36.1412138",
      "poi_longitude": "-95.8256711",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-298-4044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a5a1-772e-8a61-dd329d97cd9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a5a1-772e-8a61-dd329d97cd9d",
        "storage_key": "property/6767906449165623/019cfb46-a5a1-772e-8a61-dd329d97cd9d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJffM4REPztocR_FoKDq6s7Zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_3df9228c-0ffd-44cf-8311-ee5169277f6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Hilti - Operations Center Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9c6a-703f-b7d1-c2159fea3ab8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9c6a-703f-b7d1-c2159fea3ab8",
        "storage_key": "property/6767906449165623/019cfb46-9c6a-703f-b7d1-c2159fea3ab8.webp",
        "width": 760,
        "height": 512
      },
      "poi_business_url": "http://hilti.to/ubo2wq",
      "poi_directions_map_url": "https://maps.google.com/?cid=4109057745683559288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hilti---operations-center-corporate-office",
      "poi_latitude": "36.0872879",
      "poi_longitude": "-95.8430938",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-252-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-8ce9e8decdcd",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUE4gPGMtocReDMJvT9OBjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_791d73a9-3c85-4440-998b-6fbb75775ac3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Enovation Controls",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5311 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9d9e-756e-b49f-3a7de0640c2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9d9e-756e-b49f-3a7de0640c2a",
        "storage_key": "property/6767906449165623/019cfb46-9d9e-756e-b49f-3a7de0640c2a.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.enovationcontrols.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1461315099535642429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "enovation-controls",
      "poi_latitude": "36.0861778",
      "poi_longitude": "-95.8391635",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-317-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-8ce9e8decdcd",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_tas_OMtocRPY-8NFeiRxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_fc4cd1a5-f402-4885-a2ba-791d9a7118b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Air Hygiene International, Inc. - Stack and Emissions Testing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 W Tacoma St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9e1b-76cd-8a85-06f33cb3e7cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9e1b-76cd-8a85-06f33cb3e7cc",
        "storage_key": "property/6767906449165623/019cfb46-9e1b-76cd-8a85-06f33cb3e7cc.webp",
        "width": 1280,
        "height": 613
      },
      "poi_business_url": "https://www.airhygiene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17853602463665443212&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-hygiene-international-inc---stack-and-emissions-testing",
      "poi_latitude": "36.0713795",
      "poi_longitude": "-95.8092029",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-307-8865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-8ce9e8decdcd",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Ut31oWLtocRjFHRJ9m8xPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_25b864b1-1611-4d94-aa29-4b070253080e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "City of Broken Arrow",
      "poi_type": "Major Employers & Offices",
      "poi_address": "220 S 1st St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-9ea6-764e-be28-00ef0c70065d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb46-9ea6-764e-be28-00ef0c70065d",
        "storage_key": "property/6767906449165623/019cfb46-9ea6-764e-be28-00ef0c70065d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.brokenarrowok.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11981682047998685423&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-broken-arrow",
      "poi_latitude": "36.0510555",
      "poi_longitude": "-95.7899817",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2a8-77dc-b84b-85db4346a70f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2a8-77dc-b84b-85db4346a70f",
        "storage_key": "property/6767906449165623/019cfb46-a2a8-77dc-b84b-85db4346a70f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmQP1vMOLtocR7_CiSld8R6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_d07dd4eb-7b71-4e53-abda-f70be409ecd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Corporate Woods BUSINESS COMPLEX",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4500 S 129th E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9788116077842907967&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "corporate-woods-business-complex",
      "poi_latitude": "36.0989323",
      "poi_longitude": "-95.8380328",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-8ce9e8decdcd",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkwPveuqMtocRP8MdkLZf1oc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9980d510-db14-427a-a014-06faea3d4cf4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7912-da99-707e-8bf8-56ac2445f3f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-da99-707e-8bf8-56ac2445f3f5",
        "storage_key": "property/6767906449165623/019d7912-da99-707e-8bf8-56ac2445f3f5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.050518",
      "poi_longitude": "-95.9530171",
      "poi_miles_from_property": "13.1 mi",
      "poi_walking_minutes": "4 hours 51 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2a4-7679-8e66-95c3fce71710.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2a4-7679-8e66-95c3fce71710",
        "storage_key": "property/6767906449165623/019cfb46-a2a4-7679-8e66-95c3fce71710.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_eb6e6cba-f9e7-409b-b206-1c103426089d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Oklahoma State University Center for Health Sciences",
      "poi_type": "Education",
      "poi_address": "717 S Houston Ave # 200, Tulsa, OK 74127, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://medicine.okstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14426676051692162656&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-state-university-center-for-health-sciences",
      "poi_latitude": "36.1471963",
      "poi_longitude": "-95.9975585",
      "poi_miles_from_property": "17.4 mi",
      "poi_walking_minutes": "6 hours 25 mins",
      "poi_biking_minutes": "1 hour 31 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-586-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2a4-7679-8e66-95c3fce71710.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2a4-7679-8e66-95c3fce71710",
        "storage_key": "property/6767906449165623/019cfb46-a2a4-7679-8e66-95c3fce71710.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW_QYv3HrtocRYA6_5m7ZNcg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_293662b3-9c98-486a-8ad1-ddd5f5705464",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Phillips Theological Seminary",
      "poi_type": "Education",
      "poi_address": "901 N Mingo Rd, Tulsa, OK 74116, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7912-d559-7006-a238-e5ecf872e916.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d559-7006-a238-e5ecf872e916",
        "storage_key": "property/6767906449165623/019d7912-d559-7006-a238-e5ecf872e916.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://ptstulsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3549108837960466093&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "phillips-theological-seminary",
      "poi_latitude": "36.1679695",
      "poi_longitude": "-95.868212",
      "poi_miles_from_property": "12.8 mi",
      "poi_walking_minutes": "4 hours 39 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-610-8303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2a4-7679-8e66-95c3fce71710.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2a4-7679-8e66-95c3fce71710",
        "storage_key": "property/6767906449165623/019cfb46-a2a4-7679-8e66-95c3fce71710.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTxl481nytocRrT7VI6_3QDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_a6481ba3-0456-4bc2-b8c1-0d167d79ec44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Spartan College of Aeronautics and Technology",
      "poi_type": "Education",
      "poi_address": "8820 E Pine St, Tulsa, OK 74115, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7912-d928-77fe-8c5e-98ff4eabaf2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d928-77fe-8c5e-98ff4eabaf2d",
        "storage_key": "property/6767906449165623/019d7912-d928-77fe-8c5e-98ff4eabaf2d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.spartan.edu/tulsa/?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_content=website&utm_cid=7096",
      "poi_directions_map_url": "https://maps.google.com/?cid=3444753171937408527&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "spartan-college-of-aeronautics-and-technology",
      "poi_latitude": "36.1763534",
      "poi_longitude": "-95.87889090000002",
      "poi_miles_from_property": "13.1 mi",
      "poi_walking_minutes": "4 hours 48 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 918-393-3686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2a4-7679-8e66-95c3fce71710.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2a4-7679-8e66-95c3fce71710",
        "storage_key": "property/6767906449165623/019cfb46-a2a4-7679-8e66-95c3fce71710.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9YiEnmjytocRD7Y6QMI4zi8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_1639d4ae-afc9-4e7e-ab8c-2382c28ee504",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Hideaway Pizza",
      "poi_type": "Restaurants",
      "poi_address": "1150 N 9th St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Local chain featuring build-your-own pies, a variety of Italian fare & a kids' menu.",
      "poi_long_description": "People say this pizza restaurant serves delicious pizza with a variety of toppings, as well as fried mushrooms, chicken Alfredo, and sandwiches. They highlight the fun, lively atmosphere, and the friendly, attentive staff. They also like the reasonable prices and happy hour specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7912-d571-77ad-983e-84e89c42f996.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d571-77ad-983e-84e89c42f996",
        "storage_key": "property/6767906449165623/019d7912-d571-77ad-983e-84e89c42f996.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.hideawaypizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1339553825205242410&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hideaway-pizza",
      "poi_latitude": "36.0638722",
      "poi_longitude": "-95.7804534",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-286-1777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a28b-70ae-b6b8-8e352bd6fccd",
        "storage_key": "property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNYMvTraLtocRKsrfVBsNlxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_e77374bb-15a5-4d0c-b4e2-4dc8517bf7a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Smokies Hickory House BBQ",
      "poi_type": "Restaurants",
      "poi_address": "5251 E Kenosha St, Broken Arrow, OK 74014, USA",
      "poi_short_description": "Low-key, family-owned standby with old-school BBQ plates, sandwiches & sides, plus outdoor seating.",
      "poi_long_description": "People say this barbecue restaurant serves delicious ribs, brisket, and bologna, with sides like onion rings and fried okra. They highlight the generous portions, good value, and the friendly, attentive service. They also like the rustic, old-school atmosphere and the smell of smoked meats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7912-de26-7256-af96-fefde9c1a6a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-de26-7256-af96-fefde9c1a6a8",
        "storage_key": "property/6767906449165623/019d7912-de26-7256-af96-fefde9c1a6a8.webp",
        "width": 647,
        "height": 1015
      },
      "poi_business_url": "http://smokieshickoryhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16382291836170244764&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "smokies-hickory-house-bbq",
      "poi_latitude": "36.0604866",
      "poi_longitude": "-95.7252401",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-357-1113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a28b-70ae-b6b8-8e352bd6fccd",
        "storage_key": "property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6RxWtuBhtocRnJK1vaCXWeM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_db46e455-b8a4-410b-8bb3-98b6afec6207",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Buffalo Wild Wings",
      "poi_type": "Restaurants",
      "poi_address": "1151 N 20th St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain dishing up wings, tenders & burgers, plus sauces ranging from sweet to very spicy.",
      "poi_long_description": "People say this chicken wings restaurant serves delicious wings with plenty of sauce. They also highlight the friendly staff and the fun, lively atmosphere, especially during sporting events.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7912-e768-7556-9e60-f7b106fb5fc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-e768-7556-9e60-f7b106fb5fc0",
        "storage_key": "property/6767906449165623/019d7912-e768-7556-9e60-f7b106fb5fc0.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.buffalowildwings.com/locations/us/ok/broken-arrow/1151-north-20th-street/sports-bar-517/?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAxNjYxMjAwMC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11794872414263826856&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "buffalo-wild-wings",
      "poi_latitude": "36.0626825",
      "poi_longitude": "-95.7652101",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-286-3555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a28b-70ae-b6b8-8e352bd6fccd",
        "storage_key": "property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0ZuXkUiKtocRqNk_B_jNr6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "custom_f221d076-ace8-41eb-a480-5ef688802e0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Charleston's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "251 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Relaxed hangout serving classic pub fare, such as burgers, ribs & tenders, plus wine & cocktails.",
      "poi_long_description": "People say this American restaurant serves delicious fried catfish, prime rib, and chicken piccata. They highlight the excellent service, friendly staff, and the cozy, welcoming atmosphere, perfect for gatherings with family and friends. They also like the generous portions and reasonable prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7912-ea31-74a9-8d67-f881fc177440.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-ea31-74a9-8d67-f881fc177440",
        "storage_key": "property/6767906449165623/019d7912-ea31-74a9-8d67-f881fc177440.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://charlestons.com/locations/charlestons-broken-arrow/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7215259568967514265&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "charleston-s-restaurant",
      "poi_latitude": "36.0694444",
      "poi_longitude": "-95.7894444",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-355-9177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a28b-70ae-b6b8-8e352bd6fccd",
        "storage_key": "property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJecfxi7OLtocRmfiLklnAIWQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_2e66685a-8719-4350-aacf-3061d17f5237",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Casey's",
      "poi_type": "Restaurants",
      "poi_address": "2400 E Albany St, Broken Arrow, OK 74014, USA",
      "poi_short_description": "Convenience-store chain offering fuel, drinks & food, including pizza, sandwiches & baked goods.",
      "poi_long_description": "People say this pizza restaurant offers good pizza and snacks.\n\nOther reviews mention the pizza can be unavailable and the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7912-eead-72fb-b19b-cb7de1291f76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-eead-72fb-b19b-cb7de1291f76",
        "storage_key": "property/6767906449165623/019d7912-eead-72fb-b19b-cb7de1291f76.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.caseys.com/general-store/ok-brokenarrow/2400-e-albany-st/3479?utm_medium=organic&utm_source=google&utm_campaign=DAC",
      "poi_directions_map_url": "https://maps.google.com/?cid=9931042834177477697&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "casey-s",
      "poi_latitude": "36.0759834",
      "poi_longitude": "-95.7608002",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-553-7609",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a28b-70ae-b6b8-8e352bd6fccd",
        "storage_key": "property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs2i7-FmKtocRQUxWPNcm0ok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_d777a277-f884-4038-b85e-dcd8056006d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Domino's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "2409 N 23rd St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Delivery/carryout chain offering a wide range of pizzas & a variety of other dishes & sides.",
      "poi_long_description": "People say this pizza delivery service offers fresh and perfect pizzas.\n\nOther reviews mention orders can be incorrect and the service can be impolite.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7912-f5bf-77eb-8537-20c6a7a755da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-f5bf-77eb-8537-20c6a7a755da",
        "storage_key": "property/6767906449165623/019d7912-f5bf-77eb-8537-20c6a7a755da.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dominos.com/en/?utm_source=google&utm_medium=loclist&utm_campaign=localmaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=16856141889463307058&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "domino-s-pizza",
      "poi_latitude": "36.0621924",
      "poi_longitude": "-95.7581163",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-615-3315",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-8ce9e8decdcd",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKz1UG0eKtocRMssKpb0L7ek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_delivery"
    },
    {
      "id": "custom_c43aada3-049d-43ac-9522-8a5a042cddc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Subway",
      "poi_type": "Restaurants",
      "poi_address": "1054 E Albany St Suite B, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Casual counter-serve chain for build-your-own sandwiches & salads, with health-conscious options.",
      "poi_long_description": "People say this sandwich shop offers good sandwiches.\n\nOther reviews mention the service can be slow and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7912-f8e5-704a-9f69-100e842d1d1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-f8e5-704a-9f69-100e842d1d1c",
        "storage_key": "property/6767906449165623/019d7912-f8e5-704a-9f69-100e842d1d1c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://restaurants.subway.com/united-states/ok/broken-arrow/1054-east-albany-street?utm_source=yxt-goog&utm_medium=local&utm_term=acq&utm_content=47596&utm_campaign=evergreen-2020&y_source=1_MTQ5MTA3MjctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3332125549880455902&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "subway",
      "poi_latitude": "36.0761979",
      "poi_longitude": "-95.7786878",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-355-0091",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a28b-70ae-b6b8-8e352bd6fccd",
        "storage_key": "property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo1DHTKmLtocR3rKgg4gWPi4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_f58ceebb-dd21-4520-9566-2ebca98ee3b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "McDonald's",
      "poi_type": "Restaurants",
      "poi_address": "1250 E Albany St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Classic, long-running fast-food chain known for its burgers & fries.",
      "poi_long_description": "Some diners say this fast food restaurant is clean and the staff are friendly, using customers' names from the McDonald's app to personalize their experience.\n\nOther reviews mention the orders can be inaccurate and the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7912-faef-717d-a1b7-93e32c530f06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-faef-717d-a1b7-93e32c530f06",
        "storage_key": "property/6767906449165623/019d7912-faef-717d-a1b7-93e32c530f06.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mcdonalds.com/us/en-us/location/OK/BROKEN-ARROW/1250-E-ALBANY-ST/33834.html?cid=RF:YXT:GMB::Clicks",
      "poi_directions_map_url": "https://maps.google.com/?cid=9262211542560127912&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mcdonald-s",
      "poi_latitude": "36.075948",
      "poi_longitude": "-95.7781953",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-355-0378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a28b-70ae-b6b8-8e352bd6fccd",
        "storage_key": "property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1XELh6uLtocRqLvRHFP8iYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_daf6dbce-cb5e-4e04-8815-55f4d37d8a58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Subs & Mo!",
      "poi_type": "Restaurants",
      "poi_address": "2006 W Houston St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Family-owned shop with a range of classic and specialty subs, plus wraps, salads, and side dishes.",
      "poi_long_description": "People say this restaurant serves delicious subs, sandwiches, and sides, including the pastrami sandwich, gyro, and potato salad. They highlight the generous portions, reasonable prices, and fresh ingredients. They also like the friendly staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7912-ffbe-7059-89dd-08f437fd9fb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-ffbe-7059-89dd-08f437fd9fb0",
        "storage_key": "property/6767906449165623/019d7912-ffbe-7059-89dd-08f437fd9fb0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9509992417610849651&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "subs-mo",
      "poi_latitude": "36.046848",
      "poi_longitude": "-95.8137015",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a28b-70ae-b6b8-8e352bd6fccd",
        "storage_key": "property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkbxp1heLtocRc11avLdH-oM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_225d75fe-6c6f-428f-8fd3-9ce707d4d836",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "1150 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-0452-744e-a640-543938a9c607.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0452-744e-a640-543938a9c607",
        "storage_key": "property/6767906449165623/019d7913-0452-744e-a640-543938a9c607.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/10855",
      "poi_directions_map_url": "https://maps.google.com/?cid=13258182748225610381&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "36.0669",
      "poi_longitude": "-95.77611",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-615-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-658f-727f-8f88-c8849f1d8901.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-658f-727f-8f88-c8849f1d8901",
        "storage_key": "property/6767906449165623/019d7913-658f-727f-8f88-c8849f1d8901.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJjSo4zLOLtocRjSIz8_aG_rc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_7a69df53-5285-4605-a32d-740dcc1946e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1301 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "People say this Italian restaurant serves delicious fettuccine alfredo and bread sticks. They also highlight the friendly staff and attentive service.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-0267-7128-8065-b408a8dc852e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0267-7128-8065-b408a8dc852e",
        "storage_key": "property/6767906449165623/019d7913-0267-7128-8065-b408a8dc852e.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ok/broken-arrow/broken-arrow/1812?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:broken-arrow-ok-1812_pl:locurl_rd:1657",
      "poi_directions_map_url": "https://maps.google.com/?cid=5471937596139504696&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "36.064343",
      "poi_longitude": "-95.775177",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-355-2738",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a28b-70ae-b6b8-8e352bd6fccd",
        "storage_key": "property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn-L3eLSLtocROAQAi0A68Es",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_2584f673-c53a-4b9e-8de8-bbf6de765d0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Main Street Tavern",
      "poi_type": "Restaurants",
      "poi_address": "200 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Restaurant/sports bar featuring classic American food, late-night pub grub, live jazz & happy hour.",
      "poi_long_description": "People say this restaurant serves delicious burgers, fish and chips, and steaks. They also highlight the friendly service, laid-back atmosphere, and reasonable prices.\n\nSome reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-01d8-75ad-b3b2-0c92e819b31d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-01d8-75ad-b3b2-0c92e819b31d",
        "storage_key": "property/6767906449165623/019d7913-01d8-75ad-b3b2-0c92e819b31d.webp",
        "width": 550,
        "height": 445
      },
      "poi_business_url": "https://www.scarpa-rc.com/main-street-tavern",
      "poi_directions_map_url": "https://maps.google.com/?cid=16367268087796209159&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "main-street-tavern",
      "poi_latitude": "36.0512715",
      "poi_longitude": "-95.7909875",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-872-1414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a28b-70ae-b6b8-8e352bd6fccd",
        "storage_key": "property/6767906449165623/019cfb46-a28b-70ae-b6b8-8e352bd6fccd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdREoT8KLtocRBxauvJs3JOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_02b374d1-3fed-4196-994a-96aab660876b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Bass Pro Shops",
      "poi_type": "Shopping & Retail",
      "poi_address": "101 Bass Pro Drive, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain known for its large, wilderness-themed stores & wide array of hunting, fishing & outdoor gear.",
      "poi_long_description": "People say this sporting goods store offers a wide selection of hunting, fishing, and outdoor gear, as well as clothing and home decor. They highlight the fun and festive atmosphere, especially during the holidays, and the interesting attractions like the fish tanks and trout pond. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-0890-7671-bf31-c13e67b21830.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0890-7671-bf31-c13e67b21830",
        "storage_key": "property/6767906449165623/019d7913-0890-7671-bf31-c13e67b21830.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.basspro.com/us/ok/broken-arrow/101-bass-pro-dr.html?y_source=1_MzAxMTUyNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14650999968817088325&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bass-pro-shops",
      "poi_latitude": "36.0709381",
      "poi_longitude": "-95.7921204",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-355-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2af-75eb-86ef-cd315a63dfdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2af-75eb-86ef-cd315a63dfdb",
        "storage_key": "property/6767906449165623/019cfb46-a2af-75eb-86ef-cd315a63dfdb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhSZm66KLtocRRQea6djOUss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_fa6141c4-152f-4e2b-9e23-5bbf38d197f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "3900 E Hillside Dr, Broken Arrow, OK 74014, USA",
      "poi_short_description": "Electronics, home goods and groceries are sold at this clean supercenter along with toys, clothing, furniture and more. Friendly staff.",
      "poi_long_description": "People say this department store offers a wide selection of products and supplies. They also highlight the convenient online ordering and delivery service, and the helpful staff.\n\nOther reviews mention the store can be busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-0d49-756b-a00a-fc68cf94328e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0d49-756b-a00a-fc68cf94328e",
        "storage_key": "property/6767906449165623/019d7913-0d49-756b-a00a-fc68cf94328e.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/4637-broken-arrow-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11534022720491201746&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "36.0667326",
      "poi_longitude": "-95.742045",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-355-1024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2af-75eb-86ef-cd315a63dfdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2af-75eb-86ef-cd315a63dfdb",
        "storage_key": "property/6767906449165623/019cfb46-a2af-75eb-86ef-cd315a63dfdb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqQZU2UuKtocR0qQp7o0UEaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_d75f0f5d-dad4-49ba-af61-e04634fcdf4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "851 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "People say this grocery store offers a wide selection of healthy, organic, and allergy-friendly foods, including fresh produce and a variety of spices. They also highlight the clean and well-organized store, and the friendly and helpful staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-0be5-733b-a474-e357f167fe72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0be5-733b-a474-e357f167fe72",
        "storage_key": "property/6767906449165623/019d7913-0be5-733b-a474-e357f167fe72.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sprouts.com/store/ok/broken-arrow/broken-arrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=15446441561898677919&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "36.0670665",
      "poi_longitude": "-95.7812788",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-806-0810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a299-7199-8d9d-638a4b10273d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a299-7199-8d9d-638a4b10273d",
        "storage_key": "property/6767906449165623/019cfb46-a299-7199-8d9d-638a4b10273d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWdP2WLCLtocRn_bMBMPIXNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_fa2e74cb-fbc0-4330-856a-1c01b4a4f7e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "2-story enclosed mall with many chain stores & boutiques, plus a kids’ play area & a food court.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and a large food court. They also highlight the clean and safe atmosphere, and the fun activities like a Ferris wheel and carousel.\n\nOther reviews mention the mall can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-0e44-77ac-ba95-5ff4beba18fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0e44-77ac-ba95-5ff4beba18fc",
        "storage_key": "property/6767906449165623/019d7913-0e44-77ac-ba95-5ff4beba18fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2af-75eb-86ef-cd315a63dfdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2af-75eb-86ef-cd315a63dfdb",
        "storage_key": "property/6767906449165623/019cfb46-a2af-75eb-86ef-cd315a63dfdb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_25f8c21e-f3e6-4908-931c-020f9f3fbdcf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1150 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide selection of products. They also highlight the friendly and helpful service, and the clean and organized store.\n\nOther reviews mention the pickup service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-1330-70dc-aae0-2640724320c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-1330-70dc-aae0-2640724320c2",
        "storage_key": "property/6767906449165623/019d7913-1330-70dc-aae0-2640724320c2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/broken-arrow/2422",
      "poi_directions_map_url": "https://maps.google.com/?cid=14603451760596788981&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "36.0670278",
      "poi_longitude": "-95.7765664",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-615-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2af-75eb-86ef-cd315a63dfdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2af-75eb-86ef-cd315a63dfdb",
        "storage_key": "property/6767906449165623/019cfb46-a2af-75eb-86ef-cd315a63dfdb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjSo4zLOLtocR9abs_ADiqco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_97fc5fec-76a7-4ded-bb2e-530e6ac4872b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Reasor's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1100 E Kenosha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Grocery store at Arrow Village Shopping Center featuring prepared foods, organic products, and a pharmacy.",
      "poi_long_description": "People say this grocery store offers a wide selection of groceries, beverages, and prepared meals. They also highlight the clean and organized store, and the friendly and helpful staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019dbbe7-8124-750e-9663-d9585c7a9a18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe7-8124-750e-9663-d9585c7a9a18",
        "storage_key": "property/6767906449165623/019dbbe7-8124-750e-9663-d9585c7a9a18.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.reasors.com/stores/broken-arrow-north-lynn-lane",
      "poi_directions_map_url": "https://maps.google.com/?cid=10274984733838978513&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "reasor-s",
      "poi_latitude": "36.0619311",
      "poi_longitude": "-95.7773472",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-251-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a299-7199-8d9d-638a4b10273d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a299-7199-8d9d-638a4b10273d",
        "storage_key": "property/6767906449165623/019cfb46-a299-7199-8d9d-638a4b10273d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc3Jmb7aLtocR0a0IHS0UmI4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_53729df6-fb98-4f65-8a26-14bfa76c4213",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Wedding Florals Demo",
      "poi_type": "Shopping & Retail",
      "poi_address": "2651 N 17th St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://weddingflorals.net/location/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10257520361082259390&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wedding-florals-demo",
      "poi_latitude": "36.0798804",
      "poi_longitude": "-95.7667898",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-399-2292",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2af-75eb-86ef-cd315a63dfdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2af-75eb-86ef-cd315a63dfdb",
        "storage_key": "property/6767906449165623/019cfb46-a2af-75eb-86ef-cd315a63dfdb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVVWxClaKtocRvgel9msIWo4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "florist"
    },
    {
      "id": "custom_30e366c4-9121-4fd7-8388-cb15b83437c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Tiger Threads",
      "poi_type": "Shopping & Retail",
      "poi_address": "2200 N 23rd St Suite 161, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-289f-757d-9991-3997cd6d3949.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-289f-757d-9991-3997cd6d3949",
        "storage_key": "property/6767906449165623/019d7913-289f-757d-9991-3997cd6d3949.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.batigerthreads.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5952696614087797849&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tiger-threads",
      "poi_latitude": "36.0734622",
      "poi_longitude": "-95.7622111",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-259-4856",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2af-75eb-86ef-cd315a63dfdb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2af-75eb-86ef-cd315a63dfdb",
        "storage_key": "property/6767906449165623/019cfb46-a2af-75eb-86ef-cd315a63dfdb.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzdHIZVGKtocRWaxfIgg6nFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_1b038e73-245b-4c2c-b631-8f66d1d240db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2351 N 9th St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-33f4-7516-8872-1991f2d8c5fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-33f4-7516-8872-1991f2d8c5fc",
        "storage_key": "property/6767906449165623/019d7913-33f4-7516-8872-1991f2d8c5fc.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/broken-arrow-ok-pharmacies/2351-n-9th-st-broken-arrow-ok-74012/storeid=8279?WT.mc_id=LS_GOOGLE_RX_8279",
      "poi_directions_map_url": "https://maps.google.com/?cid=9077221913816901510&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "36.0748702",
      "poi_longitude": "-95.7787116",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-355-1293",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-6706-74a4-bc75-6e330c2f1cf5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-6706-74a4-bc75-6e330c2f1cf5",
        "storage_key": "property/6767906449165623/019d7913-6706-74a4-bc75-6e330c2f1cf5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL6aEya6LtocRhqdyyDzF-H0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_00e7a57d-a3ed-4d60-9536-f633dca6fe8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "2400 W Kenosha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "People say this supermarket offers a wide selection of pantry staples, bread, and snacks, including the Aldi brand. They highlight the great prices, convenient size, and the quality of the house brands. They also like the cordial cashiers and the quick and easy shopping experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-3e02-72ca-9022-f60c309749dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3e02-72ca-9022-f60c309749dd",
        "storage_key": "property/6767906449165623/019d7913-3e02-72ca-9022-f60c309749dd.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ok/broken-arrow/2400-w-kenosha-street/f274",
      "poi_directions_map_url": "https://maps.google.com/?cid=3044546698895851077&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "36.061961",
      "poi_longitude": "-95.820913",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a299-7199-8d9d-638a4b10273d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a299-7199-8d9d-638a4b10273d",
        "storage_key": "property/6767906449165623/019cfb46-a299-7199-8d9d-638a4b10273d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWclC5nOMtocRRX7GiRdnQCo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_3f782b73-630a-4b40-8ad6-ee7ea76225a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Veterans Park",
      "poi_type": "Entertainment",
      "poi_address": "1111 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Peaceful memorial park featuring a pond and a fountain as well as statues and silhouettes dedicated to veterans.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-28de-705e-8c91-f61003ab6e23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-28de-705e-8c91-f61003ab6e23",
        "storage_key": "property/6767906449165623/019d7913-28de-705e-8c91-f61003ab6e23.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.brokenarrowok.gov/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=13040150364334288258&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "veterans-park",
      "poi_latitude": "36.041633",
      "poi_longitude": "-95.7904006",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-259-7007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a289-7694-9648-e79069790701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a289-7694-9648-e79069790701",
        "storage_key": "property/6767906449165623/019cfb46-a289-7694-9648-e79069790701.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWd0bh96LtocRgm3Tq6rr97Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_26e9205c-c5b0-4711-afe1-baf58f6e5cbf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Nienhuis Park Community Center",
      "poi_type": "Entertainment",
      "poi_address": "3201 N 9th St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Gathering place featuring a rec room, a gym & event space, plus activities for all ages.",
      "poi_long_description": "Gathering place featuring a rec room, a gym & event space, plus activities for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-2ee3-70d2-8d2d-708e3b46ed88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-2ee3-70d2-8d2d-708e3b46ed88",
        "storage_key": "property/6767906449165623/019d7913-2ee3-70d2-8d2d-708e3b46ed88.webp",
        "width": 1280,
        "height": 979
      },
      "poi_business_url": "https://www.brokenarrowok.gov/government/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=3825451967442187919&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "nienhuis-park-community-center",
      "poi_latitude": "36.084739",
      "poi_longitude": "-95.778864",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-259-6550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-8ce9e8decdcd",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Quh8AaLtocRj_a12Eu8FjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "custom_d714ec93-a86c-42cd-ba3c-be590fff602f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Rose District",
      "poi_type": "Entertainment",
      "poi_address": "123 N Main St Suite A, Broken Arrow, OK 74013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-3128-706e-b288-759d4caffb06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3128-706e-b288-759d4caffb06",
        "storage_key": "property/6767906449165623/019d7913-3128-706e-b288-759d4caffb06.webp",
        "width": 940,
        "height": 352
      },
      "poi_business_url": "https://rosedistrict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17372178648733973550&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rose-district",
      "poi_latitude": "36.0532147",
      "poi_longitude": "-95.7904814",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-259-6511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a2a8-77dc-b84b-85db4346a70f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a2a8-77dc-b84b-85db4346a70f",
        "storage_key": "property/6767906449165623/019cfb46-a2a8-77dc-b84b-85db4346a70f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV60cQYaaX68RLvxpdHBgFvE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_e8f5bc95-71fb-4c24-a19e-24236f13524d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Ray Harral Nature Park & Center",
      "poi_type": "Entertainment",
      "poi_address": "7101 S 3rd St, Broken Arrow, OK 74011, USA",
      "poi_short_description": "40-acre park with a peaceful feel, an on-site nature center, picnic facilities & fishing.",
      "poi_long_description": "People say this park offers short, paved, and well-maintained trails suitable for walking, hiking, and strolling. They highlight the beautiful forest setting, shady trails, and the convenient location tucked behind schools and a neighborhood. They also like the informative nature center with hands-on activities and displays about local wildlife.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-422a-72e2-a948-e7317f92f9c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-422a-72e2-a948-e7317f92f9c7",
        "storage_key": "property/6767906449165623/019d7913-422a-72e2-a948-e7317f92f9c7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.facebook.com/RayHarralNatureCenter/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3946947640467703348&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ray-harral-nature-park-center",
      "poi_latitude": "35.984247",
      "poi_longitude": "-95.786704",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-615-6099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a289-7694-9648-e79069790701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a289-7694-9648-e79069790701",
        "storage_key": "property/6767906449165623/019cfb46-a289-7694-9648-e79069790701.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJK_BQieWItocRNMYkmfdfxjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bf80b29a-a1eb-407e-8f60-e0799f341eff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Haikey Creek Park",
      "poi_type": "Entertainment",
      "poi_address": "11327 S Garnett Rd, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Vast county park boasting picnic area & playgrounds, plus an 18-hole championship disc golf course.",
      "poi_long_description": "People say this park offers a variety of activities, including playgrounds, disc golf, hiking trails, and picnic areas. They highlight the spaciousness, well-maintained grounds, and clean restrooms. They also like the peaceful and family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-3afa-70a1-9695-c14827c70efd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-3afa-70a1-9695-c14827c70efd",
        "storage_key": "property/6767906449165623/019d7913-3afa-70a1-9695-c14827c70efd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15453125230281067031&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "haikey-creek-park",
      "poi_latitude": "35.9918271",
      "poi_longitude": "-95.8526659",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "3 hours 53 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 918-369-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a289-7694-9648-e79069790701.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a289-7694-9648-e79069790701",
        "storage_key": "property/6767906449165623/019cfb46-a289-7694-9648-e79069790701.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz_xefyOtocRF4qH1IWHdNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7eb2668a-40f9-401d-bdec-7730fb16a5f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Tulsa Art Deco Mini Museum",
      "poi_type": "Entertainment",
      "poi_address": "1401 E 11th St Unit B, Tulsa, OK 74120, USA",
      "poi_short_description": "Quaint mini-museum featuring art deco exhibits, in addition to rotating displays.",
      "poi_long_description": "People say this gift shop offers a wide variety of toys, games, puzzles, vintage gifts, and candy, as well as Tulsa merchandise and postcards. They highlight the unique and creative store layout, with themed alcoves and a mini Art Deco museum, and the fun, nostalgic, and adventurous vibe. They also like the friendly and chill staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-41fd-7426-b67c-f47c85f06219.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-41fd-7426-b67c-f47c85f06219",
        "storage_key": "property/6767906449165623/019d7913-41fd-7426-b67c-f47c85f06219.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://decopolis.net/pages/decopolis-tulsa-art-deco-museum",
      "poi_directions_map_url": "https://maps.google.com/?cid=17497514271019039304&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-art-deco-mini-museum",
      "poi_latitude": "36.1480744",
      "poi_longitude": "-95.9729723",
      "poi_miles_from_property": "16.2 mi",
      "poi_walking_minutes": "5 hours 58 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-382-7388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a299-7199-8d9d-6671445c434f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a299-7199-8d9d-6671445c434f",
        "storage_key": "property/6767906449165623/019cfb46-a299-7199-8d9d-6671445c434f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJp1uZ_3vrtocRSPpqEIao0_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_cc6ef8ce-3830-4e03-8037-28035faaeaf8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Broken Arrow Performing Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "701 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Contemporary 1,500-seat venue hosting an array of shows, including Broadway tours & pop concerts.",
      "poi_long_description": "People say this performing arts theater offers a nice selection of music and passionate performances in an intimate setting. They highlight the beautiful venue, great sound, and accessible seating, as well as the clean and well-organized facilities. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-4d1b-740d-85d9-acf510aa5b4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4d1b-740d-85d9-acf510aa5b4c",
        "storage_key": "property/6767906449165623/019d7913-4d1b-740d-85d9-acf510aa5b4c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.brokenarrowpac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1015494257798968490&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "broken-arrow-performing-arts-center",
      "poi_latitude": "36.04614979999999",
      "poi_longitude": "-95.7900528",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-259-5778",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-8ce9e8decdcd",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx9lh4dyLtocRqnSOq6XCFw4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_38ee99db-d092-4278-aa8b-7441472c90d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "poi_name": "Broken Arrow Golf And Athletic Club",
      "poi_type": "Entertainment",
      "poi_address": "1651 E Omaha St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019d7913-5409-775d-b92a-9c86d85e1a3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-5409-775d-b92a-9c86d85e1a3b",
        "storage_key": "property/6767906449165623/019d7913-5409-775d-b92a-9c86d85e1a3b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.brokenarrowgolfac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3979361832891395148&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "broken-arrow-golf-and-athletic-club",
      "poi_latitude": "36.0879108",
      "poi_longitude": "-95.7676297",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-355-0602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb46-a293-7247-9b31-8ce9e8decdcd",
        "storage_key": "property/6767906449165623/019cfb46-a293-7247-9b31-8ce9e8decdcd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJecbPEvyKtocRTCw94oCIOTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    }
  ],
  "office_hours": [
    {
      "id": "ec_9f43fad6ce4c12eee6932f87",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_d42429e56e5e1c8046454b07",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_fb800f0eff722cf3600fd555",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0a09d0aef31578f2ccedace7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_5d76c5fee024a260f35809d1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_1e1b765a352f37d363eeab2a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_7c7d88b4-0880-41cf-a4a9-44d3da865a97",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "rating": "5.0",
      "name": "Patricia Y",
      "text": "Great place to live!  General apartment pro's and con's no matter where you go, like the occasional noisy neighbors and typically around Known \"drinking holidays.\"  THOSE moments though have not been consistent or unreasonable, yet.  Just life :)   Great turn-around time on maintenance requests, easy online rent payment system, allows security devices and other safety adjustments allowed with Management's knowledge.\n\nI've lived in Numerous spots all over Tulsa & the metro areas for the last 20 years. I've been in this complex for 9 months, second floor (of 3).  I love living here; it's overall my favorite 😍",
      "date": "2025-08-13",
      "title": ""
    },
    {
      "id": "custom_38a08c30-b148-4f46-9b5f-32e321e63806",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "rating": "5.0",
      "name": "Betty Wente",
      "text": "Today Bryon came to fix 2 things for me. He was unable to open my storage door\nHe told me he needed to replace the locking system\nStated he was going to go to lunch and would be back with a new lock in 1 hr. He came back on time and I have a new lock\nHe also replaced the batteries in my thermostat. He was very kind and did excellent work",
      "date": "2025-06-13",
      "title": ""
    },
    {
      "id": "custom_153e54d4-3eba-497e-a673-9d9184a85d19",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "rating": "5.0",
      "name": "Nidia Rodriguez",
      "text": "All questions answered. Very polite young man. He presented himself very professional. Loved the layout of the apartments.",
      "date": "2025-10-06",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_8f3ec754-a939-4708-83a2-a45dd1fbc891",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb47-5759-70ae-9b33-06522dc0ec30.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of the outdoor swimming pool and lounge area at the apartment complex",
        "public_id": "019cfb47-5759-70ae-9b33-06522dc0ec30",
        "storage_key": "property/6767906449165623/019cfb47-5759-70ae-9b33-06522dc0ec30.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Redbud Ranch Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=62d52fa5de6fc024f6134a61"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-5a05-7364-ba59-4ece7538d221",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "redbud-ranch",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623"
    },
    {
      "lead_collector_id": "019cf79e-5a78-718e-ae23-4d5bdf540ee4",
      "lead_source": "LANDING_PAGE",
      "name": "redbud-ranch",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-broken-arrow",
      "search_query": "luxury apartments with pool Broken Arrow",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Broken Arrow",
      "h2_subtitle": "Discover luxury living at Redbud Ranch. Enjoy our beautiful pool and unmatched amenities in the heart of Broken Arrow.",
      "page_copy": "At Redbud Ranch, experience the epitome of luxury apartments with a pool in Broken Arrow. Our delightful community offers you a choice of spacious one, two, or three-bedroom layouts, each designed with modern comfort in mind. Whether you're enjoying a dip in our pristine pool or unwinding in the relaxing clubhouse, you’ll find everyday comfort here.\n\nRedbud Ranch not only provides a welcoming pool but also features a range of superior amenities, such as a dog park, maintenance on site, and a basketball court. The vaulted ceilings and fireplaces in our apartments further enhance the luxury living experience. Make Redbud Ranch in Broken Arrow your new home and indulge in the tranquil lifestyle you've been dreaming of.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse in the background.",
        "public_id": "019cfb46-755a-711e-ad8e-a1b3af0a0672",
        "storage_key": "property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Broken Arrow",
      "seo_description": "Explore luxury living at Redbud Ranch, Broken Arrow, featuring a stunning pool and modern amenities for your comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-with-park-broken-arrow-ok",
      "search_query": "dog-friendly apartments with park Broken Arrow OK",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments with Park in Broken Arrow",
      "h2_subtitle": "Redbud Ranch offers dog-friendly apartments with a park in Broken Arrow, OK. Enjoy a pet-loving community and excellent amenities.",
      "page_copy": "Welcome to Redbud Ranch, where our dog-friendly apartments with a park in Broken Arrow, OK provide the perfect haven for pet lovers. Our serene community invites you and your furry friends to explore and enjoy with a specialized dog park that is designed for fun and relaxation.\n\nIdeal for pet owners, Redbud Ranch not only caters to your pets but also ensures a comfortable living experience for you. Choose from our one, two, or three-bedroom floor plans, all equipped with contemporary comforts like fireplaces and vaulted ceilings. With maintenance on site, a basketball court, and our inviting pool, both you and your pets will find endless opportunities to thrive in this vibrant community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse in the background.",
        "public_id": "019cfb46-755a-711e-ad8e-a1b3af0a0672",
        "storage_key": "property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments & Park in Broken Arrow, OK",
      "seo_description": "Discover dog-friendly living at Redbud Ranch, Broken Arrow, OK with a dedicated park and top-tier amenities for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "generator",
      "page_item_url": "apartments-with-fitness-center-broken-arrow-ok-74014",
      "search_query": "apartments with fitness center Broken Arrow OK 74014",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Broken Arrow",
      "h2_subtitle": "Explore Redbud Ranch where fitness and comfort meet. Enjoy modern amenities in the heart of Broken Arrow, OK, 74014.",
      "page_copy": "At Redbud Ranch, residents can pursue an active lifestyle in our beautiful apartments with a fitness center in Broken Arrow, OK, 74014. There’s no need to travel far for workout facilities when you can enjoy staying fit just steps from your door. Redbud Ranch offers an ideal blend of convenience and leisure.\n\nBeyond the fitness center, our community features a wealth of amenities. From the gorgeous swimming pool to the dog park, and spacious floor plans with fireplaces and vaulted ceilings, our complex is designed to enhance your living experience. Maintenance on site ensures everything runs smoothly, leaving you free to enjoy life at its best. Choose Redbud Ranch as your new home and embrace the lifestyle you’ve been seeking.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse in the background.",
        "public_id": "019cfb46-755a-711e-ad8e-a1b3af0a0672",
        "storage_key": "property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in Broken Arrow",
      "seo_description": "Enjoy a fitness-focused lifestyle at Redbud Ranch in Broken Arrow, OK 74014 with modern amenities and a central location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "generator",
      "page_item_url": "rentals-with-in-unit-washer-dryer-near-broken-arrow",
      "search_query": "rentals with in-unit washer dryer near Broken Arrow",
      "category": "Amenity",
      "h1_title": "Rentals with In-Unit Washer Dryer Near Broken Arrow",
      "h2_subtitle": "Find convenient rentals near Broken Arrow with in-unit washer and dryer at Redbud Ranch, offering modern living solutions.",
      "page_copy": "Discover the ease of living at Redbud Ranch, where rentals with in-unit washer dryers near Broken Arrow redefine home convenience. Our thoughtfully designed apartments offer spacious one, two, or three-bedroom floor plans, allowing you the freedom to choose a space that suits your lifestyle.\n\nLife at Redbud Ranch not only provides you with in-unit conveniences but also boasts numerous amenities including a refreshing pool, a dedicated dog park for pet enthusiasts, and a well-equipped clubhouse. With superior features such as fireplaces and vaulted ceilings, along with on-site maintenance and a basketball court, you’ll find everything you need in our vibrant Broken Arrow community. Come home to comfort and elegance at Redbud Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse in the background.",
        "public_id": "019cfb46-755a-711e-ad8e-a1b3af0a0672",
        "storage_key": "property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals with In-Unit Washer Dryer Near Broken Arrow",
      "seo_description": "Experience convenience at Redbud Ranch, offering rentals near Broken Arrow with in-unit washer and dryer and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "generator",
      "page_item_url": "broken-arrow-apartments-with-air-conditioning",
      "search_query": "Broken Arrow apartments with air conditioning",
      "category": "Amenity",
      "h1_title": "Broken Arrow Apartments with Air Conditioning",
      "h2_subtitle": "Stay cool at Redbud Ranch. Enjoy comfortable living with air-conditioned apartments right in Broken Arrow, OK.",
      "page_copy": "Embrace comfort and style at Redbud Ranch, where our Broken Arrow apartments with air conditioning provide a refreshing retreat all year round. Situated in the vibrant community of Broken Arrow, OK, our modern apartments are designed to keep you cool and comfortable, regardless of the season.\n\nBeyond air-conditioned interiors, Redbud Ranch offers a wealth of amenities designed to enhance your lifestyle. Relax by our inviting pool, take advantage of the dog park, or enjoy a game on the basketball court. Inside, you'll find elegant features such as fireplaces and vaulted ceilings that complement the spacious floor plans. With maintenance on site, you can enjoy a stress-free living environment tailored to meet all your needs. Discover the relaxing lifestyle waiting for you at Redbud Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse in the background.",
        "public_id": "019cfb46-755a-711e-ad8e-a1b3af0a0672",
        "storage_key": "property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Comfortable Broken Arrow Apartments with AC",
      "seo_description": "Live comfortably at Redbud Ranch in Broken Arrow, offering air-conditioned apartments and a host of modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-broken-arrow",
      "search_query": "one bedroom apartments broken arrow",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Broken Arrow",
      "h2_subtitle": "Experience modern living at Redbud Ranch. Our one-bedroom apartments offer the perfect blend of comfort and style.",
      "page_copy": "At Redbud Ranch, our one-bedroom apartments in Broken Arrow offer an ideal mix of style and practicality. Each unit is thoughtfully designed to maximize space and provide a comfortable living experience with features that cater to your lifestyle.\n\nOur community is more than just a place to live; it’s a retreat where you can unwind. Enjoy amenities such as a sparkling pool, dog park, and on-site basketball court. Apartments come with modern conveniences like fireplaces and vaulted ceilings, creating a warm and inviting atmosphere. With easy access to local attractions in Broken Arrow, Redbud Ranch is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse in the background.",
        "public_id": "019cfb46-755a-711e-ad8e-a1b3af0a0672",
        "storage_key": "property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Broken Arrow",
      "seo_description": "Find your new home at Redbud Ranch. Our one-bedroom apartments in Broken Arrow offer modern amenities and stylish living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-74014",
      "search_query": "two bedroom apartments near 74014",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 74014",
      "h2_subtitle": "Discover spacious two-bedroom apartments near the 74014 area at Redbud Ranch in Broken Arrow, offering convenience and modern amenities.",
      "page_copy": "Redbud Ranch in Broken Arrow proudly presents spacious two-bedroom apartments near the 74014 zip code area, perfect for those seeking room to grow without compromising on comfort or location. Our community is designed to offer the utmost satisfaction, with numerous features that cater to both relaxation and active lifestyles.\n\nOur two-bedroom apartments are not only spacious but also thoughtfully equipped with modern amenities such as fireplaces and vaulted ceilings for a refined living experience. Step outside to enjoy our beautifully maintained pool, dog park, and on-site basketball court. With prompt maintenance services and a welcoming clubhouse, Redbud Ranch makes it easy to feel right at home, just minutes from everything the 74014 area has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse in the background.",
        "public_id": "019cfb46-755a-711e-ad8e-a1b3af0a0672",
        "storage_key": "property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 74014",
      "seo_description": "Explore Redbud Ranch in Broken Arrow, offering modern two-bedroom apartments near the 74014 area with luxurious amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-in-tulsa-county",
      "search_query": "three bedroom apartments in tulsa county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Tulsa County",
      "h2_subtitle": "Explore spacious three-bedroom apartments in Tulsa County at Redbud Ranch. Perfect for families seeking comfortable living with modern amenities.",
      "page_copy": "Experience a new level of family living with our three-bedroom apartments in Tulsa County, located at Redbud Ranch in Broken Arrow. Our apartments are tailored to provide ample space and comfort, ensuring an ideal environment for families or those in need of extra space.\n\nEach three-bedroom apartment is designed with contemporary amenities, including fireplaces and vaulted ceilings, enhancing your living experience. At Redbud Ranch, you’ll find more than a home; our community offers a range of amenities like a relaxing pool, a dog park for your furry friends, and a basketball court. Conveniently located with access to local attractions in Tulsa County, Redbud Ranch combines comfort and convenience seamlessly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse in the background.",
        "public_id": "019cfb46-755a-711e-ad8e-a1b3af0a0672",
        "storage_key": "property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Tulsa County",
      "seo_description": "Find spacious three-bedroom apartments at Redbud Ranch in Tulsa County, offering modern living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "generator",
      "page_item_url": "apartments-near-tulsa-community-college-southeast",
      "search_query": "apartments near tulsa community college southeast campus",
      "category": "School",
      "h1_title": "Apartments Near Tulsa Community College SE",
      "h2_subtitle": "Discover convenient living at Redbud Ranch, just a short drive from Tulsa Community College Southeast Campus.",
      "page_copy": "At Redbud Ranch, our community is perfectly situated for students and professionals seeking apartments near Tulsa Community College Southeast Campus. Located in Broken Arrow, our apartments provide an ideal balance of convenience and comfort, with easy access to campus and local attractions.\n\nChoose from our variety of spacious floor plans, which include one, two, and three-bedroom layouts, all featuring modern amenities such as fireplaces and vaulted ceilings. Our community amenities, including a refreshing pool, a lively dog park, and a well-maintained basketball court, ensure a balanced lifestyle for residents. Enjoy the proximity to Tulsa Community College Southeast Campus while relishing the comforts of home at Redbud Ranch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse in the background.",
        "public_id": "019cfb46-755a-711e-ad8e-a1b3af0a0672",
        "storage_key": "property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tulsa Community College SE",
      "seo_description": "Live close to Tulsa Community College Southeast Campus at Redbud Ranch, offering convenient, modern apartment living in Broken Arrow.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "generator",
      "page_item_url": "redbud-ranch-near-nsu-broken-arrow",
      "search_query": "redbud ranch near northeastern state university broken arrow",
      "category": "School",
      "h1_title": "Redbud Ranch Near NSU Broken Arrow",
      "h2_subtitle": "Live at Redbud Ranch, near Northeastern State University in Broken Arrow. Enjoy modern living minutes from campus.",
      "page_copy": "Discover the perfect blend of convenience and comfort at Redbud Ranch, ideally located near Northeastern State University in Broken Arrow. Whether you are a student who wants to stay close to campus or someone seeking a well-connected living environment, our community is a top choice.\n\nRedbud Ranch offers a variety of spacious floor plans with luxurious amenities such as fireplaces, vaulted ceilings, and more. Residents can enjoy a range of conveniences including a beautiful pool, a dog park for pet lovers, and a basketball court for active living. With its prime location, Redbud Ranch gives you easy access to NSU Broken Arrow, ensuring you're never far from both academic and local pursuits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse in the background.",
        "public_id": "019cfb46-755a-711e-ad8e-a1b3af0a0672",
        "storage_key": "property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Redbud Ranch Near NSU Broken Arrow",
      "seo_description": "Explore Redbud Ranch, located near Northeastern State University Broken Arrow, with modern amenities and convenient access to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "generator",
      "page_item_url": "apartments-near-council-oak-healthcare-broken-arrow",
      "search_query": "apartments near Council Oak Comprehensive Healthcare Broken Arrow",
      "category": "Hospital",
      "h1_title": "Apartments Near Council Oak Healthcare",
      "h2_subtitle": "Live close to Council Oak Comprehensive Healthcare at Redbud Ranch in Broken Arrow. Enjoy both convenience and comfort in your new home.",
      "page_copy": "If proximity to healthcare is a priority, Redbud Ranch offers well-located apartments near Council Oak Comprehensive Healthcare in Broken Arrow. Residents here enjoy a community that provides convenience and modern living, just moments away from essential healthcare services.\n\nOur community provides a selection of spacious one, two, and three-bedroom apartment homes featuring amenities such as fireplaces and vaulted ceilings. At Redbud Ranch, you'll not only live near important services but also enjoy features like a sparkling pool, a welcoming clubhouse, and a dog park, enhancing your lifestyle both indoors and outdoors. With easy access to Council Oak Comprehensive Healthcare, residents enjoy peace of mind while living in comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse in the background.",
        "public_id": "019cfb46-755a-711e-ad8e-a1b3af0a0672",
        "storage_key": "property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Council Oak Healthcare",
      "seo_description": "Find modern living at Redbud Ranch, just minutes from Council Oak Comprehensive Healthcare in Broken Arrow, offering spacious apartments and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "generator",
      "page_item_url": "apartments-close-to-ascension-st-john-broken-arrow",
      "search_query": "apartments close to Ascension St. John Broken Arrow",
      "category": "Hospital",
      "h1_title": "Apartments Close to Ascension St. John",
      "h2_subtitle": "Experience the convenience of living at Redbud Ranch, just a short distance from Ascension St. John in Broken Arrow.",
      "page_copy": "Redbud Ranch offers an exceptional living experience if you're searching for apartments close to Ascension St. John Broken Arrow. Located in the vibrant community of Broken Arrow, our apartments provide modern conveniences and easy access to healthcare.\n\nWith spacious floor plans, Redbud Ranch guarantees comfort through its one, two, and three-bedroom options, each featuring amenities like fireplaces and vaulted ceilings. Our residents enjoy community perks such as a serene pool, a pet-friendly dog park, and a welcoming clubhouse. Being near Ascension St. John, residents can have the dual benefits of superior healthcare access while enjoying a modern home environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse in the background.",
        "public_id": "019cfb46-755a-711e-ad8e-a1b3af0a0672",
        "storage_key": "property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Ascension St. John",
      "seo_description": "Live at Redbud Ranch, offering modern apartments near Ascension St. John Broken Arrow. Enjoy convenience and comfort in a thriving community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "generator",
      "page_item_url": "apartments-near-rhema-park-broken-arrow",
      "search_query": "apartments near Rhema Park Broken Arrow",
      "category": "Park",
      "h1_title": "Apartments Near Rhema Park, Broken Arrow",
      "h2_subtitle": "Enjoy the serene lifestyle at Redbud Ranch, located near the beautiful Rhema Park in Broken Arrow.",
      "page_copy": "Embrace tranquility and modern living at Redbud Ranch, where you'll find apartments near Rhema Park in Broken Arrow. This location provides residents with a peaceful retreat while keeping you connected to the local community attractions.\n\nOur property features a variety of floor plans with luxurious amenities such as vaulted ceilings and cozy fireplaces. Enjoy leisure time at the sparkling pool, play on the basketball court, or take your furry friend to the dog park. With Rhema Park just moments away, you can explore its scenic beauty and relaxing walking trails, making Redbud Ranch an ideal choice for those seeking both activity and calm in their lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse in the background.",
        "public_id": "019cfb46-755a-711e-ad8e-a1b3af0a0672",
        "storage_key": "property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rhema Park, Broken Arrow",
      "seo_description": "Discover Redbud Ranch, with modern apartments close to Rhema Park in Broken Arrow, offering amenities and a connection to local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "generator",
      "page_item_url": "redbud-ranch-apartments-close-to-elam-park",
      "search_query": "Redbud Ranch apartments close to Elam Park",
      "category": "Park",
      "h1_title": "Redbud Ranch Near Elam Park",
      "h2_subtitle": "Discover the charm of living at Redbud Ranch, conveniently close to Elam Park in Broken Arrow.",
      "page_copy": "At Redbud Ranch, enjoy residing in a convenient location with easy access to Elam Park in Broken Arrow. Our community is designed to offer a balance of comfort and local accessibility, perfect for those who value a serene environment near recreational spots.\n\nSelect from our spacious one, two, or three-bedroom apartments, featuring modern amenities like fireplaces and vaulted ceilings. Residents can enjoy community offerings like a relaxing pool, a dog park for pets, and a clubhouse for social gatherings. With Elam Park just a short distance away, you can enjoy leisurely walks or picnics, making Redbud Ranch ideal for those seeking active and peaceful living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse in the background.",
        "public_id": "019cfb46-755a-711e-ad8e-a1b3af0a0672",
        "storage_key": "property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Redbud Ranch Near Elam Park",
      "seo_description": "Live at Redbud Ranch, close to Elam Park in Broken Arrow, offering modern apartments with community amenities for a balanced lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "generator",
      "page_item_url": "apartment-living-by-jackson-park-broken-arrow",
      "search_query": "apartment living by Jackson Park Broken Arrow OK",
      "category": "Park",
      "h1_title": "Apartment Living by Jackson Park",
      "h2_subtitle": "Experience exceptional apartment living at Redbud Ranch, situated near Jackson Park in Broken Arrow, OK.",
      "page_copy": "Discover Redbud Ranch, where apartment living by Jackson Park becomes an experience of convenience and comfort in Broken Arrow, OK. Our location offers residents the opportunity to enjoy a vibrant lifestyle just moments away from one of the area's beloved green spaces.\n\nChoose from spacious and stylish floor plans including one, two, and three-bedroom options, each equipped with modern amenities like vaulted ceilings and cozy fireplaces. Enjoy a host of on-site features, from the inviting swimming pool to the vibrant clubhouse. Indoor and outdoor pet-friendly facilities, such as a dedicated dog park, further enhance the community experience, especially with Jackson Park's recreational opportunities so close by.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse in the background.",
        "public_id": "019cfb46-755a-711e-ad8e-a1b3af0a0672",
        "storage_key": "property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Living by Jackson Park",
      "seo_description": "Enjoy modern living at Redbud Ranch, near Jackson Park in Broken Arrow, OK. Discover spacious layouts and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165623",
      "source": "generator",
      "page_item_url": "broken-arrow-apartments-near-nienhuis-park",
      "search_query": "Broken Arrow apartments near Nienhuis Park",
      "category": "Park",
      "h1_title": "Broken Arrow Apartments Near Nienhuis Park",
      "h2_subtitle": "Find your ideal home at Redbud Ranch, perfectly located near Nienhuis Park in Broken Arrow.",
      "page_copy": "Redbud Ranch offers ideal apartments near Nienhuis Park, allowing residents to enjoy the blend of suburban tranquility and vibrant community life in Broken Arrow. With its close proximity to nature, our community is perfect for those who love outdoor activities and relaxation.\n\nOur spacious, modern apartments feature one, two, and three-bedroom layouts equipped with luxurious amenities, including cozy fireplaces and high vaulted ceilings. Enjoy an active lifestyle with a basketball court, take a dip in the refreshing pool, or socialize at the clubhouse. Pet lovers will appreciate the dog park available on-site, offering fun for furry companions just a stone’s throw from beautiful Nienhuis Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern clubhouse in the background.",
        "public_id": "019cfb46-755a-711e-ad8e-a1b3af0a0672",
        "storage_key": "property/6767906449165623/019cfb46-755a-711e-ad8e-a1b3af0a0672.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Broken Arrow Apartments Near Nienhuis Park",
      "seo_description": "Explore Redbud Ranch, offering modern apartments near Nienhuis Park in Broken Arrow. Enjoy excellent amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5205"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-CWDTQTY64P"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151315"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/redbud-ranch/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WQK4V8BN"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165623/019d1bd9-722a-75cf-8c0d-fb1b3d4f8c42.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "0bead8c3-3fdf-4664-b5e8-297ac5d79404"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-332-4936"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64651db6bafcddf75a1cf8f7"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InBpSkRjdnhnMjJwcGEzOUVWSmtodkE9PSIsInZhbHVlIjoiM2VBMFBNRHF6bDg4amZjcW1SVkhBdz09IiwibWFjIjoiNDgzN2U1YmM2MjdlYTZlNjcyY2MzOGUzOTI2MTE1MTY4ZjY2MzYyODQ3MjI4YTRkNDY4MWNmZjYyMmY0ZGYwOCJ9"
    }
  ],
  "custom_qb_id": "5205",
  "custom_ga4_id": "G-CWDTQTY64P",
  "custom_repli_id": "10041151315",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/redbud-ranch/register/",
  "custom_google_gtm_id": "GTM-WQK4V8BN",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165623/019d1bd9-722a-75cf-8c0d-fb1b3d4f8c42.pdf",
  "custom_rentgrata_property_id": "0bead8c3-3fdf-4664-b5e8-297ac5d79404",
  "custom_ppc_tracking_phone_number": "844-332-4936",
  "custom_residentboost_apartment_id": "64651db6bafcddf75a1cf8f7",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InBpSkRjdnhnMjJwcGEzOUVWSmtodkE9PSIsInZhbHVlIjoiM2VBMFBNRHF6bDg4amZjcW1SVkhBdz09IiwibWFjIjoiNDgzN2U1YmM2MjdlYTZlNjcyY2MzOGUzOTI2MTE1MTY4ZjY2MzYyODQ3MjI4YTRkNDY4MWNmZjYyMmY0ZGYwOCJ9"
};

export const generatedAt = '2026-08-27T21:37:01.619Z';
